var map = {
  "./remixicon/design/layout-3-fill.svg": [
    "41172",
    "78360"
  ],
  "./remixicon/media/hq-line.svg": [
    "98331",
    "15752"
  ],
  "./remixicon/design/hexagon-line.svg": [
    "53982",
    "61317"
  ],
  "./remixicon/arrows/arrow-right-wide-line.svg": [
    "40451",
    "77990"
  ],
  "./extensions/pdf.svg": [
    "65682",
    "67763"
  ],
  "./remixicon/document/file-unknow-line.svg": [
    "55194",
    "56904"
  ],
  "./fullscreen-arrows.svg": [
    "66265",
    "89606"
  ],
  "./remixicon/editor/slash-commands-2.svg": [
    "84186",
    "40614"
  ],
  "./remixicon/design/layout-left-2-line.svg": [
    "26690",
    "89042"
  ],
  "./extensions/video.svg": [
    "47738",
    "57725"
  ],
  "./question-rounded-fill.svg": [
    "38338",
    "80198"
  ],
  "./remixicon/media/forward-10-line.svg": [
    "66508",
    "13520"
  ],
  "./remixicon/design/align-item-right-line.svg": [
    "29519",
    "33488"
  ],
  "./remixicon/design/layout-vertical-fill.svg": [
    "85300",
    "20282"
  ],
  "./remixicon/media/image-line.svg": [
    "76116",
    "26946"
  ],
  "./remixicon/media/rewind-mini-line.svg": [
    "99042",
    "61722"
  ],
  "./remixicon/design/flip-horizontal-line.svg": [
    "18043",
    "20976"
  ],
  "./remixicon/media/stop-mini-fill.svg": [
    "47615",
    "38608"
  ],
  "./remixicon/editor/list-check-2.svg": [
    "94667",
    "31609"
  ],
  "./remixicon/design/brush-3-line.svg": [
    "87016",
    "16431"
  ],
  "./remixicon/design/layout-top-2-line.svg": [
    "94440",
    "49548"
  ],
  "./remixicon/editor/text.svg": [
    "68618",
    "54895"
  ],
  "./line-double.svg": [
    "55088",
    "62849"
  ],
  "./check-in-calendar.svg": [
    "81978",
    "3500"
  ],
  "./remixicon/editor/bold.svg": [
    "53514",
    "40252"
  ],
  "./remixicon/design/edit-box-fill.svg": [
    "93502",
    "77588"
  ],
  "./lesson-module-latex.svg": [
    "83620",
    "84279"
  ],
  "./remixicon/editor/code-block.svg": [
    "72641",
    "35069"
  ],
  "./empty-homework.svg": [
    "83381",
    "16364"
  ],
  "./layer2.svg": [
    "17976",
    "74735"
  ],
  "./remixicon/arrows/expand-up-down-fill.svg": [
    "67922",
    "99826"
  ],
  "./remixicon/editor/kanban-view-2.svg": [
    "18537",
    "69674"
  ],
  "./remixicon/media/picture-in-picture-2-line.svg": [
    "82274",
    "13799"
  ],
  "./remixicon/design/grid-line.svg": [
    "9610",
    "5495"
  ],
  "./remixicon/design/layout-grid-2-fill.svg": [
    "47458",
    "76066"
  ],
  "./arrow-zigzag1.svg": [
    "69141",
    "4564"
  ],
  "./gear.svg": [
    "41684",
    "62205"
  ],
  "./list-unordered.svg": [
    "60266",
    "92136"
  ],
  "./remixicon/design/shape-fill.svg": [
    "53039",
    "97911"
  ],
  "./angle-up.svg": [
    "12789",
    "43918"
  ],
  "./layers.svg": [
    "13456",
    "249"
  ],
  "./notifications/status/check-circle.svg": [
    "37292",
    "93555"
  ],
  "./remixicon/arrows/contract-right-fill.svg": [
    "81003",
    "83687"
  ],
  "./remixicon/editor/list-indefinite.svg": [
    "41300",
    "57354"
  ],
  "./remixicon/design/table-line.svg": [
    "81402",
    "13013"
  ],
  "./remixicon/editor/split-cells-horizontal.svg": [
    "18074",
    "4996"
  ],
  "./remixicon/document/todo-fill.svg": [
    "61132",
    "82240"
  ],
  "./cloud-search.svg": [
    "54000",
    "20287"
  ],
  "./palette.svg": [
    "58054",
    "22226"
  ],
  "./remixicon/document/file-warning-fill.svg": [
    "53066",
    "55893"
  ],
  "./remixicon/media/movie-line.svg": [
    "56364",
    "79880"
  ],
  "./remixicon/document/file-paper-2-fill.svg": [
    "77330",
    "68671"
  ],
  "./message.svg": [
    "82328",
    "88373"
  ],
  "./remixicon/document/folder-info-fill.svg": [
    "5359",
    "91566"
  ],
  "./remixicon/editor/sort-number-asc.svg": [
    "42396",
    "80719"
  ],
  "./remixicon/media/rewind-mini-fill.svg": [
    "82837",
    "95311"
  ],
  "./remixicon/media/skip-forward-fill.svg": [
    "5074",
    "10155"
  ],
  "./remixicon/document/file-paper-2-line.svg": [
    "97802",
    "17875"
  ],
  "./lock-rounded.svg": [
    "6929",
    "21599"
  ],
  "./remixicon/editor/align-bottom.svg": [
    "49499",
    "19311"
  ],
  "./remixicon/media/video-download-fill.svg": [
    "43682",
    "33782"
  ],
  "./remixicon/document/file-word-fill.svg": [
    "40025",
    "88178"
  ],
  "./remixicon/media/video-on-fill.svg": [
    "30783",
    "27742"
  ],
  "./soc-vk-sharp.svg": [
    "75406",
    "46872"
  ],
  "./triangle-rounded-up.svg": [
    "29251",
    "57438"
  ],
  "./remixicon/document/file-hwp-line.svg": [
    "96484",
    "23103"
  ],
  "./remixicon/arrows/corner-up-left-double-fill.svg": [
    "61027",
    "74797"
  ],
  "./add-webinars.svg": [
    "65149",
    "93029"
  ],
  "./cloud-upload.svg": [
    "77825",
    "857"
  ],
  "./address-card.svg": [
    "61208",
    "18251"
  ],
  "./remixicon/arrows/arrow-down-s-line.svg": [
    "48047",
    "90477"
  ],
  "./remixicon/document/folder-close-line.svg": [
    "47966",
    "407"
  ],
  "./remixicon/design/palette-line.svg": [
    "14027",
    "398"
  ],
  "./plus-round.svg": [
    "3873",
    "51892"
  ],
  "./circle-arrow-process-left.svg": [
    "50757",
    "99463"
  ],
  "./remixicon/media/forward-30-fill.svg": [
    "69011",
    "25111"
  ],
  "./remixicon/arrows/arrow-right-down-fill.svg": [
    "43152",
    "48738"
  ],
  "./remixicon/media/rhythm-line.svg": [
    "20709",
    "83061"
  ],
  "./separation.svg": [
    "14692",
    "29949"
  ],
  "./remixicon/document/book-line.svg": [
    "91228",
    "47806"
  ],
  "./sort.svg": [
    "71425",
    "5181"
  ],
  "./remixicon/design/anticlockwise-fill.svg": [
    "26067",
    "79792"
  ],
  "./trash.svg": [
    "51719",
    "42418"
  ],
  "./arrow-refresh.svg": [
    "35202",
    "30006"
  ],
  "./remixicon/arrows/arrow-left-circle-fill.svg": [
    "39137",
    "25677"
  ],
  "./mail-convert.svg": [
    "71049",
    "46498"
  ],
  "./remixicon/media/stop-large-line.svg": [
    "76860",
    "41397"
  ],
  "./remixicon/design/contrast-drop-2-fill.svg": [
    "5244",
    "23460"
  ],
  "./basket.svg": [
    "46342",
    "23894"
  ],
  "./line-dashed.svg": [
    "24452",
    "61498"
  ],
  "./remixicon/design/flip-horizontal-2-fill.svg": [
    "64435",
    "56305"
  ],
  "./remixicon/document/book-3-line.svg": [
    "60567",
    "28579"
  ],
  "./remixicon/media/music-line.svg": [
    "28127",
    "48709"
  ],
  "./remixicon/document/file-code-fill.svg": [
    "65724",
    "39504"
  ],
  "./remixicon/media/replay-30-fill.svg": [
    "53450",
    "21371"
  ],
  "./remixicon/design/artboard-2-fill.svg": [
    "97154",
    "1792"
  ],
  "./remixicon/document/keynote-fill.svg": [
    "85743",
    "38004"
  ],
  "./remixicon/editor/double-quotes-l.svg": [
    "84312",
    "92124"
  ],
  "./remixicon/media/notification-fill.svg": [
    "56231",
    "52785"
  ],
  "./balance.svg": [
    "92573",
    "12236"
  ],
  "./course-continue.svg": [
    "5510",
    "96714"
  ],
  "./people-plus.svg": [
    "27523",
    "61191"
  ],
  "./remixicon/design/crop-line.svg": [
    "42962",
    "7326"
  ],
  "./remixicon/media/mv-line.svg": [
    "64364",
    "60273"
  ],
  "./remixicon/media/speaker-2-fill.svg": [
    "13086",
    "28451"
  ],
  "./remixicon/media/eject-fill.svg": [
    "79760",
    "75891"
  ],
  "./remixicon/media/stop-circle-line.svg": [
    "27152",
    "22004"
  ],
  "./remixicon/media/forward-end-mini-fill.svg": [
    "35783",
    "82153"
  ],
  "./remixicon/arrows/arrow-left-up-fill.svg": [
    "56641",
    "16091"
  ],
  "./remixicon/design/hammer-fill.svg": [
    "26643",
    "5915"
  ],
  "./remixicon/document/contacts-book-upload-fill.svg": [
    "31645",
    "48767"
  ],
  "./star-full.svg": [
    "29748",
    "1160"
  ],
  "./remixicon/document/folder-shield-line.svg": [
    "12977",
    "76964"
  ],
  "./remixicon/media/play-mini-fill.svg": [
    "70420",
    "4113"
  ],
  "./remixicon/design/screenshot-2-fill.svg": [
    "37651",
    "27661"
  ],
  "./image-square.svg": [
    "44882",
    "55067"
  ],
  "./remixicon/design/square-line.svg": [
    "48743",
    "22752"
  ],
  "./remixicon/media/play-reverse-large-fill.svg": [
    "78374",
    "46830"
  ],
  "./notifications/notification-settings.svg": [
    "47736",
    "68528"
  ],
  "./remixicon/arrows/corner-up-right-line.svg": [
    "6576",
    "76431"
  ],
  "./remixicon/media/play-list-2-line.svg": [
    "40017",
    "83934"
  ],
  "./time-wait.svg": [
    "71554",
    "63898"
  ],
  "./remixicon/document/folder-download-line.svg": [
    "52401",
    "48195"
  ],
  "./wrench-simple-role.svg": [
    "8692",
    "61920"
  ],
  "./plus-rounded.svg": [
    "37781",
    "65179"
  ],
  "./remixicon/editor/single-quotes-r.svg": [
    "58873",
    "80057"
  ],
  "./cloud-up.svg": [
    "82448",
    "47230"
  ],
  "./pen.svg": [
    "95529",
    "25530"
  ],
  "./remixicon/editor/slideshow-view.svg": [
    "45190",
    "96391"
  ],
  "./sparkles.svg": [
    "56059",
    "89021"
  ],
  "./user-move.svg": [
    "41309",
    "67322"
  ],
  "./remixicon/document/bill-line.svg": [
    "72348",
    "44377"
  ],
  "./remixicon/document/newspaper-fill.svg": [
    "20063",
    "7256"
  ],
  "./landscape-second-loopers.svg": [
    "49899",
    "48074"
  ],
  "./remixicon/design/scissors-line.svg": [
    "74539",
    "6889"
  ],
  "./remixicon/arrows/scroll-to-bottom-line.svg": [
    "37382",
    "76394"
  ],
  "./check.svg": [
    "87746",
    "79996"
  ],
  "./remixicon/media/polaroid-2-fill.svg": [
    "27626",
    "71858"
  ],
  "./course-completed.svg": [
    "85291",
    "10792"
  ],
  "./remixicon/design/layout-right-2-fill.svg": [
    "40193",
    "42581"
  ],
  "./remixicon/editor/align-top.svg": [
    "56874",
    "78247"
  ],
  "./remixicon/design/contrast-2-fill.svg": [
    "83516",
    "8301"
  ],
  "./remixicon/media/play-large-line.svg": [
    "32830",
    "54602"
  ],
  "./remixicon/media/tape-fill.svg": [
    "56001",
    "93739"
  ],
  "./envelope-dot.svg": [
    "60508",
    "14812"
  ],
  "./remixicon/media/video-off-line.svg": [
    "802",
    "13480"
  ],
  "./card-plus.svg": [
    "54279",
    "73988"
  ],
  "./remixicon/arrows/arrow-left-down-fill.svg": [
    "66008",
    "61771"
  ],
  "./advertising.svg": [
    "92557",
    "72941"
  ],
  "./remixicon/media/pause-mini-fill.svg": [
    "761",
    "15476"
  ],
  "./callout-note.svg": [
    "19635",
    "11364"
  ],
  "./remixicon/media/notification-2-line.svg": [
    "90267",
    "4450"
  ],
  "./remixicon/media/shuffle-line.svg": [
    "76926",
    "73415"
  ],
  "./free.svg": [
    "35885",
    "68644"
  ],
  "./remixicon/media/dv-line.svg": [
    "4125",
    "19671"
  ],
  "./zoom-out.svg": [
    "24962",
    "19647"
  ],
  "./bicolor/difficult-level-low.svg": [
    "20202",
    "47852"
  ],
  "./money-input.svg": [
    "87921",
    "46490"
  ],
  "./remixicon/arrows/corner-up-left-fill.svg": [
    "4985",
    "86293"
  ],
  "./remixicon/design/sip-fill.svg": [
    "16299",
    "43846"
  ],
  "./remixicon/media/image-circle-line.svg": [
    "44296",
    "65951"
  ],
  "./plan-optimal.svg": [
    "6468",
    "25257"
  ],
  "./cloud-desynced.svg": [
    "73887",
    "9144"
  ],
  "./text-lines.svg": [
    "21281",
    "22777"
  ],
  "./remixicon/document/file-3-line.svg": [
    "3774",
    "35426"
  ],
  "./remixicon/editor/indent-decrease.svg": [
    "85725",
    "68923"
  ],
  "./remixicon/document/book-marked-line.svg": [
    "86855",
    "89371"
  ],
  "./remixicon/arrows/arrow-left-wide-line.svg": [
    "45105",
    "21103"
  ],
  "./remixicon/document/folder-add-line.svg": [
    "8049",
    "79978"
  ],
  "./dots-vertical.svg": [
    "35982",
    "7224"
  ],
  "./liked.svg": [
    "19752",
    "3225"
  ],
  "./messages-role.svg": [
    "79945",
    "87818"
  ],
  "./remixicon/media/music-2-fill.svg": [
    "68400",
    "45663"
  ],
  "./flip-horizontal.svg": [
    "21378",
    "46433"
  ],
  "./remixicon/document/article-line.svg": [
    "53913",
    "64367"
  ],
  "./eyeShow.svg": [
    "87224",
    "98895"
  ],
  "./triangle-down.svg": [
    "33881",
    "41651"
  ],
  "./remixicon/design/brush-4-fill.svg": [
    "60592",
    "387"
  ],
  "./cross-small.svg": [
    "58121",
    "44046"
  ],
  "./remixicon/design/crosshair-line.svg": [
    "65742",
    "67700"
  ],
  "./remixicon/editor/link.svg": [
    "55292",
    "96641"
  ],
  "./remixicon/arrows/contract-left-right-fill.svg": [
    "50331",
    "42572"
  ],
  "./pin.svg": [
    "43131",
    "47651"
  ],
  "./filter-outline-crossed.svg": [
    "42",
    "84667"
  ],
  "./remixicon/design/slice-fill.svg": [
    "75981",
    "88181"
  ],
  "./remixicon/document/sticky-note-fill.svg": [
    "36979",
    "66265"
  ],
  "./remixicon/editor/translate.svg": [
    "40196",
    "53106"
  ],
  "./remixicon/media/fullscreen-exit-fill.svg": [
    "50173",
    "87271"
  ],
  "./remixicon/media/tape-line.svg": [
    "23674",
    "52970"
  ],
  "./arrow-up-round-fill.svg": [
    "37370",
    "17259"
  ],
  "./remixicon/design/focus-3-line.svg": [
    "54173",
    "61036"
  ],
  "./remixicon/document/file-excel-2-fill.svg": [
    "40524",
    "87365"
  ],
  "./remixicon/document/sticky-note-add-fill.svg": [
    "64108",
    "29805"
  ],
  "./soc-fb-messenger.svg": [
    "25434",
    "11020"
  ],
  "./file-upload.svg": [
    "28209",
    "76419"
  ],
  "./remixicon/media/speaker-2-line.svg": [
    "80639",
    "67545"
  ],
  "./remixicon/document/contacts-book-3-fill.svg": [
    "39698",
    "96570"
  ],
  "./remixicon/editor/insert-column-left.svg": [
    "71336",
    "25220"
  ],
  "./eyeHide.svg": [
    "66388",
    "88172"
  ],
  "./remixicon/media/repeat-line.svg": [
    "49902",
    "18377"
  ],
  "./remixicon/design/circle-fill.svg": [
    "36426",
    "24097"
  ],
  "./remixicon/media/speaker-fill.svg": [
    "15807",
    "6685"
  ],
  "./question.svg": [
    "3187",
    "13474"
  ],
  "./remixicon/design/artboard-2-line.svg": [
    "79663",
    "32747"
  ],
  "./remixicon/design/magic-line.svg": [
    "29786",
    "36095"
  ],
  "./remixicon/media/stop-circle-fill.svg": [
    "91446",
    "72337"
  ],
  "./remixicon/media/video-upload-fill.svg": [
    "5381",
    "95531"
  ],
  "./remixicon/editor/page-separator.svg": [
    "70489",
    "14954"
  ],
  "./remixicon/design/contrast-drop-fill.svg": [
    "95195",
    "38908"
  ],
  "./star-half.svg": [
    "13739",
    "5978"
  ],
  "./lesson-module-header.svg": [
    "57827",
    "5323"
  ],
  "./remixicon/media/hd-line.svg": [
    "34790",
    "68628"
  ],
  "./alt-info.svg": [
    "51837",
    "6231"
  ],
  "./remixicon/media/video-line.svg": [
    "67766",
    "27465"
  ],
  "./template-select-img.svg": [
    "19701",
    "88080"
  ],
  "./remixicon/document/folder-cloud-fill.svg": [
    "27326",
    "50208"
  ],
  "./remixicon/design/align-item-vertical-center-fill.svg": [
    "4040",
    "13977"
  ],
  "./remixicon/media/play-mini-line.svg": [
    "22982",
    "27155"
  ],
  "./lesson-module-callout.svg": [
    "99977",
    "43417"
  ],
  "./remixicon/editor/translate-2.svg": [
    "46164",
    "43269"
  ],
  "./arrow-revert.svg": [
    "27619",
    "73352"
  ],
  "./play-button-active.svg": [
    "75109",
    "1026"
  ],
  "./plus-circle.svg": [
    "44891",
    "59219"
  ],
  "./remixicon/document/receipt-line.svg": [
    "92721",
    "3691"
  ],
  "./webinar.svg": [
    "48139",
    "22200"
  ],
  "./publish-status.svg": [
    "87958",
    "12536"
  ],
  "./remixicon/document/file-damage-fill.svg": [
    "60562",
    "11240"
  ],
  "./dots-draggable.svg": [
    "87098",
    "70184"
  ],
  "./remixicon/design/layout-3-line.svg": [
    "88066",
    "46141"
  ],
  "./remixicon/design/markup-fill.svg": [
    "27858",
    "23350"
  ],
  "./remixicon/document/file-word-line.svg": [
    "25934",
    "67632"
  ],
  "./remixicon/media/notification-off-fill.svg": [
    "40426",
    "26310"
  ],
  "./remixicon/media/play-reverse-line.svg": [
    "21694",
    "29850"
  ],
  "./remixicon/media/speed-mini-line.svg": [
    "56969",
    "87384"
  ],
  "./arrow-expended.svg": [
    "70583",
    "21526"
  ],
  "./extensions/xd.svg": [
    "99401",
    "81106"
  ],
  "./notPublish-status.svg": [
    "13309",
    "68029"
  ],
  "./remixicon/arrows/arrow-drop-up-fill.svg": [
    "98123",
    "84207"
  ],
  "./remixicon/arrows/arrow-left-s-line.svg": [
    "66611",
    "72421"
  ],
  "./remixicon/design/crop-fill.svg": [
    "35658",
    "57925"
  ],
  "./remixicon/editor/code-view.svg": [
    "7195",
    "92664"
  ],
  "./lock-rounded-small.svg": [
    "32789",
    "31333"
  ],
  "./remixicon/editor/a-b.svg": [
    "3421",
    "72289"
  ],
  "./remixicon/media/speed-line.svg": [
    "43706",
    "75523"
  ],
  "./remixicon/arrows/drag-move-fill.svg": [
    "91421",
    "71011"
  ],
  "./remixicon/design/eraser-line.svg": [
    "72248",
    "72330"
  ],
  "./logo.svg": [
    "59183",
    "66968"
  ],
  "./remixicon/document/folder-3-fill.svg": [
    "24345",
    "40857"
  ],
  "./remixicon/media/camera-off-line.svg": [
    "3375",
    "19590"
  ],
  "./remixicon/arrows/arrow-down-double-line.svg": [
    "47007",
    "91030"
  ],
  "./remixicon/media/image-edit-fill.svg": [
    "20572",
    "83487"
  ],
  "./lesson-module-audio.svg": [
    "80509",
    "76497"
  ],
  "./remixicon/arrows/expand-left-line.svg": [
    "66110",
    "61571"
  ],
  "./remixicon/editor/hashtag.svg": [
    "57437",
    "79383"
  ],
  "./remixicon/media/mic-fill.svg": [
    "43252",
    "17998"
  ],
  "./question-select-image.svg": [
    "77224",
    "47356"
  ],
  "./remixicon/design/table-alt-fill.svg": [
    "5502",
    "60226"
  ],
  "./remixicon/editor/align-right.svg": [
    "96106",
    "33582"
  ],
  "./remixicon/editor/gallery-view.svg": [
    "41746",
    "14790"
  ],
  "./callout-target.svg": [
    "59045",
    "88595"
  ],
  "./remixicon/editor/list-check.svg": [
    "3003",
    "60785"
  ],
  "./remixicon/media/radio-fill.svg": [
    "58723",
    "46512"
  ],
  "./remixicon/media/volume-up-line.svg": [
    "10637",
    "60169"
  ],
  "./arrow-right-circle2.svg": [
    "54232",
    "17614"
  ],
  "./arrow-left-round.svg": [
    "5488",
    "6649"
  ],
  "./soc-whatsapp.svg": [
    "30075",
    "74131"
  ],
  "./list-ordered.svg": [
    "50602",
    "71936"
  ],
  "./remixicon/design/drop-line.svg": [
    "92166",
    "24211"
  ],
  "./remixicon/editor/list-check-3.svg": [
    "82154",
    "15230"
  ],
  "./remixicon/media/notification-3-fill.svg": [
    "63287",
    "1861"
  ],
  "./remixicon/media/repeat-2-line.svg": [
    "73402",
    "12229"
  ],
  "./remixicon/design/rectangle-fill.svg": [
    "23617",
    "9539"
  ],
  "./frame.svg": [
    "15407",
    "3967"
  ],
  "./remixicon/document/folder-4-fill.svg": [
    "28977",
    "5611"
  ],
  "./remixicon/media/headphone-fill.svg": [
    "86466",
    "79485"
  ],
  "./remixicon/arrows/collapse-diagonal-fill.svg": [
    "48115",
    "28291"
  ],
  "./remixicon/design/align-item-top-fill.svg": [
    "17824",
    "36081"
  ],
  "./remixicon/media/pause-mini-line.svg": [
    "56631",
    "50463"
  ],
  "./passed.svg": [
    "49687",
    "78246"
  ],
  "./question-formula.svg": [
    "19099",
    "96630"
  ],
  "./remixicon/media/film-fill.svg": [
    "41100",
    "20664"
  ],
  "./remixicon/media/repeat-2-fill.svg": [
    "85541",
    "96532"
  ],
  "./skillspace_logo_certificate.svg": [
    "78050",
    "84644"
  ],
  "./remixicon/editor/table-2.svg": [
    "93479",
    "538"
  ],
  "./extensions/unknown.svg": [
    "83728",
    "8432"
  ],
  "./remixicon/document/book-3-fill.svg": [
    "77493",
    "29539"
  ],
  "./discount.svg": [
    "67081",
    "55802"
  ],
  "./remixicon/design/scissors-fill.svg": [
    "76651",
    "60274"
  ],
  "./remixicon/document/folder-6-fill.svg": [
    "82926",
    "25834"
  ],
  "./remixicon/media/sound-module-line.svg": [
    "74286",
    "57878"
  ],
  "./notifications/main/credit-card.svg": [
    "63736",
    "69483"
  ],
  "./remixicon/arrows/corner-down-left-line.svg": [
    "31252",
    "58822"
  ],
  "./remixicon/document/folder-forbid-fill.svg": [
    "18398",
    "8365"
  ],
  "./remixicon/media/forward-10-fill.svg": [
    "91118",
    "15124"
  ],
  "./remixicon/document/sticky-note-2-fill.svg": [
    "75749",
    "59144"
  ],
  "./rotate-counter-clockwise.svg": [
    "58380",
    "76126"
  ],
  "./remixicon/design/collage-line.svg": [
    "58655",
    "33047"
  ],
  "./remixicon/media/picture-in-picture-line.svg": [
    "95342",
    "38491"
  ],
  "./remixicon/media/stop-mini-line.svg": [
    "72058",
    "75502"
  ],
  "./remixicon/document/booklet-fill.svg": [
    "23397",
    "41392"
  ],
  "./heart-role.svg": [
    "89399",
    "28834"
  ],
  "./remixicon/design/brush-2-line.svg": [
    "55531",
    "16340"
  ],
  "./remixicon/arrows/arrow-up-circle-fill.svg": [
    "75460",
    "32325"
  ],
  "./remixicon/design/ruler-line.svg": [
    "7020",
    "58091"
  ],
  "./remixicon/editor/align-justify.svg": [
    "45222",
    "37105"
  ],
  "./remixicon/media/forward-5-fill.svg": [
    "81563",
    "43845"
  ],
  "./remixicon/document/file-zip-line.svg": [
    "82017",
    "24202"
  ],
  "./bicolor/users.svg": [
    "16428",
    "77559"
  ],
  "./course-completion.svg": [
    "42581",
    "78725"
  ],
  "./remixicon/editor/indent-increase.svg": [
    "78986",
    "34749"
  ],
  "./remixicon/editor/h-4.svg": [
    "37769",
    "12119"
  ],
  "./remixicon/arrows/arrow-up-wide-fill.svg": [
    "33665",
    "68943"
  ],
  "./remixicon/arrows/expand-height-fill.svg": [
    "50333",
    "49178"
  ],
  "./user-trust.svg": [
    "68675",
    "63330"
  ],
  "./remixicon/document/numbers-line.svg": [
    "69822",
    "53757"
  ],
  "./notifications/status/arrow-circle.svg": [
    "69694",
    "13243"
  ],
  "./speedometer.svg": [
    "35293",
    "33374"
  ],
  "./remixicon/arrows/arrow-turn-forward-fill.svg": [
    "42557",
    "95370"
  ],
  "./remixicon/document/file-text-fill.svg": [
    "8765",
    "63670"
  ],
  "./plan-expert.svg": [
    "4839",
    "56504"
  ],
  "./document.svg": [
    "22012",
    "97327"
  ],
  "./gear-filled.svg": [
    "81131",
    "91281"
  ],
  "./remixicon/arrows/arrow-right-up-fill.svg": [
    "628",
    "80418"
  ],
  "./remixicon/design/markup-line.svg": [
    "90624",
    "49588"
  ],
  "./remixicon/design/artboard-fill.svg": [
    "17493",
    "69506"
  ],
  "./remixicon/document/folder-fill.svg": [
    "82447",
    "31790"
  ],
  "./partner-school.svg": [
    "42578",
    "80071"
  ],
  "./remixicon/editor/list-unordered.svg": [
    "62280",
    "37542"
  ],
  "./copy-link.svg": [
    "49264",
    "78321"
  ],
  "./remixicon/design/flip-vertical-2-fill.svg": [
    "57228",
    "649"
  ],
  "./remixicon/editor/node-tree.svg": [
    "49101",
    "31053"
  ],
  "./extensions/ae.svg": [
    "99572",
    "363"
  ],
  "./remixicon/document/file-music-fill.svg": [
    "54795",
    "12522"
  ],
  "./remixicon/design/drag-drop-fill.svg": [
    "51504",
    "18485"
  ],
  "./remixicon/document/file-pdf-line.svg": [
    "73458",
    "27871"
  ],
  "./plan-advanced.svg": [
    "43458",
    "44465"
  ],
  "./remixicon/media/movie-fill.svg": [
    "909",
    "45434"
  ],
  "./remixicon/arrows/arrow-left-up-line.svg": [
    "99158",
    "28935"
  ],
  "./dots-draggable-2.svg": [
    "87919",
    "8006"
  ],
  "./registration-webinar.svg": [
    "82858",
    "41898"
  ],
  "./remixicon/design/ruler-2-line.svg": [
    "7706",
    "84441"
  ],
  "./remixicon/document/file-unknow-fill.svg": [
    "51496",
    "88598"
  ],
  "./remixicon/editor/single-quotes-l.svg": [
    "44188",
    "68810"
  ],
  "./direction.svg": [
    "16763",
    "62945"
  ],
  "./remixicon/design/color-filter-line.svg": [
    "55790",
    "61704"
  ],
  "./remixicon/document/contract-fill.svg": [
    "71603",
    "17486"
  ],
  "./remixicon/document/file-edit-line.svg": [
    "44639",
    "27306"
  ],
  "./note-medical.svg": [
    "78984",
    "35879"
  ],
  "./remixicon/design/screenshot-fill.svg": [
    "55924",
    "30482"
  ],
  "./remixicon/document/file-cloud-line.svg": [
    "16416",
    "86332"
  ],
  "./vk.svg": [
    "1068",
    "9418"
  ],
  "./user-plus.svg": [
    "93977",
    "90223"
  ],
  "./remixicon/editor/font-size.svg": [
    "22572",
    "48434"
  ],
  "./file-download.svg": [
    "98479",
    "75094"
  ],
  "./lesson-module-list.svg": [
    "8514",
    "66671"
  ],
  "./remixicon/editor/link-unlink.svg": [
    "25591",
    "39124"
  ],
  "./remixicon/media/headphone-line.svg": [
    "51257",
    "72527"
  ],
  "./remixicon/media/stop-line.svg": [
    "34424",
    "74983"
  ],
  "./remixicon/media/volume-vibrate-fill.svg": [
    "37513",
    "60446"
  ],
  "./bicolor/courses.svg": [
    "95772",
    "66898"
  ],
  "./remixicon/document/news-fill.svg": [
    "78696",
    "81170"
  ],
  "./remixicon/document/folder-shield-fill.svg": [
    "88837",
    "38353"
  ],
  "./remixicon/editor/dropdown-list.svg": [
    "999",
    "4169"
  ],
  "./fullscreen.svg": [
    "4313",
    "79410"
  ],
  "./info.svg": [
    "36645",
    "68824"
  ],
  "./arrow-down.svg": [
    "20105",
    "12915"
  ],
  "./play.svg": [
    "88002",
    "4929"
  ],
  "./remixicon/design/pentagon-fill.svg": [
    "58",
    "84475"
  ],
  "./remixicon/document/book-2-line.svg": [
    "10857",
    "82023"
  ],
  "./remixicon/design/octagon-fill.svg": [
    "59951",
    "80504"
  ],
  "./remixicon/arrows/arrow-go-back-line.svg": [
    "7179",
    "73794"
  ],
  "./remixicon/document/file-list-3-line.svg": [
    "84818",
    "53156"
  ],
  "./remixicon/document/file-warning-line.svg": [
    "2273",
    "11870"
  ],
  "./remixicon/media/pause-line.svg": [
    "77773",
    "60573"
  ],
  "./remixicon/media/mic-off-fill.svg": [
    "40826",
    "46364"
  ],
  "./remixicon/design/eraser-fill.svg": [
    "77541",
    "76574"
  ],
  "./remixicon/design/focus-2-fill.svg": [
    "5772",
    "4919"
  ],
  "./calendar-xmark.svg": [
    "59970",
    "74351"
  ],
  "./paper.svg": [
    "98631",
    "92712"
  ],
  "./remixicon/media/equalizer-3-line.svg": [
    "84689",
    "15249"
  ],
  "./remixicon/design/brush-4-line.svg": [
    "15322",
    "86312"
  ],
  "./remixicon/media/repeat-one-line.svg": [
    "91760",
    "15160"
  ],
  "./remixicon/editor/strikethrough.svg": [
    "77359",
    "39377"
  ],
  "./close-circle.svg": [
    "3917",
    "33094"
  ],
  "./crown-role.svg": [
    "77460",
    "50099"
  ],
  "./remixicon/arrows/expand-height-line.svg": [
    "21826",
    "54907"
  ],
  "./remixicon/design/blur-off-line.svg": [
    "47603",
    "89964"
  ],
  "./remixicon/editor/input-field.svg": [
    "6116",
    "62824"
  ],
  "./remixicon/media/skip-back-fill.svg": [
    "84372",
    "73717"
  ],
  "./menu-burger.svg": [
    "13354",
    "52296"
  ],
  "./remixicon/editor/insert-row-top.svg": [
    "30506",
    "37106"
  ],
  "./remixicon/document/file-copy-line.svg": [
    "1574",
    "51953"
  ],
  "./remixicon/design/artboard-line.svg": [
    "66184",
    "11656"
  ],
  "./remixicon/arrows/arrow-drop-left-fill.svg": [
    "82003",
    "19192"
  ],
  "./callout-remember.svg": [
    "80883",
    "59140"
  ],
  "./remixicon/document/file-paper-line.svg": [
    "78969",
    "12014"
  ],
  "./remixicon/media/movie-2-line.svg": [
    "79381",
    "33068"
  ],
  "./accordion.svg": [
    "51862",
    "31971"
  ],
  "./remixicon/arrows/arrow-right-up-line.svg": [
    "55053",
    "75432"
  ],
  "./remixicon/media/camera-lens-fill.svg": [
    "61017",
    "29565"
  ],
  "./line-dot.svg": [
    "32480",
    "22435"
  ],
  "./remixicon/arrows/arrow-down-circle-fill.svg": [
    "87598",
    "13940"
  ],
  "./remixicon/design/layout-bottom-fill.svg": [
    "26506",
    "63047"
  ],
  "./course-free.svg": [
    "91551",
    "96176"
  ],
  "./more.svg": [
    "49741",
    "11628"
  ],
  "./remixicon/arrows/arrow-up-double-fill.svg": [
    "48300",
    "91950"
  ],
  "./remixicon/design/tools-fill.svg": [
    "99362",
    "77673"
  ],
  "./remixicon/editor/font-sans-serif.svg": [
    "61419",
    "32757"
  ],
  "./remixicon/media/forward-15-line.svg": [
    "49880",
    "49974"
  ],
  "./embed.svg": [
    "55562",
    "78372"
  ],
  "./remixicon/arrows/arrow-drop-down-fill.svg": [
    "52040",
    "27048"
  ],
  "./remixicon/media/music-fill.svg": [
    "25860",
    "20091"
  ],
  "./close-bold.svg": [
    "90275",
    "21924"
  ],
  "./brands/vk.svg": [
    "34728",
    "73133"
  ],
  "./hexagon-exclamation.svg": [
    "79946",
    "47889"
  ],
  "./play-circle-webinars.svg": [
    "69201",
    "92478"
  ],
  "./remixicon/arrows/contract-left-right-line.svg": [
    "55909",
    "78601"
  ],
  "./remixicon/document/task-line.svg": [
    "1923",
    "72063"
  ],
  "./brands/youtube.svg": [
    "96105",
    "6486"
  ],
  "./remixicon/media/replay-15-line.svg": [
    "60815",
    "7459"
  ],
  "./lesson-module-embed.svg": [
    "3061",
    "40858"
  ],
  "./remixicon/media/volume-down-fill.svg": [
    "70450",
    "97996"
  ],
  "./remixicon/arrows/arrow-right-down-line.svg": [
    "98382",
    "50473"
  ],
  "./rounded-right.svg": [
    "11538",
    "46609"
  ],
  "./remixicon/arrows/arrow-down-circle-line.svg": [
    "34199",
    "87125"
  ],
  "./info-notify.svg": [
    "20598",
    "91701"
  ],
  "./arrow-right-angle.svg": [
    "3607",
    "43728"
  ],
  "./remixicon/design/pantone-line.svg": [
    "67973",
    "47454"
  ],
  "./remixicon/media/camera-switch-fill.svg": [
    "68733",
    "75111"
  ],
  "./remixicon/editor/rounded-corner.svg": [
    "59881",
    "69426"
  ],
  "./remixicon/editor/focus-mode.svg": [
    "93812",
    "12568"
  ],
  "./remixicon/media/equalizer-3-fill.svg": [
    "52357",
    "70832"
  ],
  "./bicolor/skillspace-logo-rounded.svg": [
    "53749",
    "9709"
  ],
  "./soc-telegram-square.svg": [
    "16550",
    "15021"
  ],
  "./user-invoited.svg": [
    "75971",
    "36823"
  ],
  "./remixicon/document/folder-settings-fill.svg": [
    "37865",
    "31260"
  ],
  "./remixicon/media/live-fill.svg": [
    "78715",
    "48888"
  ],
  "./angle-right.svg": [
    "76718",
    "38268"
  ],
  "./bicolor/channel.svg": [
    "12930",
    "4098"
  ],
  "./list-check.svg": [
    "5355",
    "82166"
  ],
  "./remixicon/arrows/arrow-down-line.svg": [
    "23386",
    "14884"
  ],
  "./remixicon/design/pentagon-line.svg": [
    "82779",
    "41679"
  ],
  "./remixicon/document/folder-music-fill.svg": [
    "43620",
    "360"
  ],
  "./remixicon/arrows/arrow-left-line.svg": [
    "62229",
    "85652"
  ],
  "./remixicon/arrows/scroll-to-bottom-fill.svg": [
    "3307",
    "40211"
  ],
  "./remixicon/editor/h-6.svg": [
    "55826",
    "88657"
  ],
  "./remixicon/design/circle-line.svg": [
    "53370",
    "43988"
  ],
  "./database-plus.svg": [
    "20575",
    "12673"
  ],
  "./remixicon/media/camera-line.svg": [
    "44143",
    "68294"
  ],
  "./remixicon/media/replay-10-line.svg": [
    "33409",
    "45537"
  ],
  "./soc-instagram-square.svg": [
    "98296",
    "25784"
  ],
  "./remixicon/design/align-item-bottom-fill.svg": [
    "76428",
    "8751"
  ],
  "./remixicon/design/layout-left-line.svg": [
    "40012",
    "84534"
  ],
  "./remixicon/media/pause-fill.svg": [
    "75190",
    "32266"
  ],
  "./remixicon/media/play-list-2-fill.svg": [
    "39090",
    "96378"
  ],
  "./error-notify.svg": [
    "98393",
    "89051"
  ],
  "./comment-info.svg": [
    "42209",
    "36651"
  ],
  "./remixicon/document/news-line.svg": [
    "35992",
    "31136"
  ],
  "./remixicon/editor/calendar-view.svg": [
    "948",
    "14806"
  ],
  "./settings-tune.svg": [
    "86338",
    "27762"
  ],
  "./remixicon/document/file-ppt-line.svg": [
    "94305",
    "34806"
  ],
  "./remixicon/media/mv-fill.svg": [
    "6555",
    "77833"
  ],
  "./remixicon/document/folder-history-fill.svg": [
    "3850",
    "7402"
  ],
  "./remixicon/design/focus-3-fill.svg": [
    "70094",
    "43452"
  ],
  "./remixicon/document/file-chart-fill.svg": [
    "54008",
    "17584"
  ],
  "./lesson-module-images.svg": [
    "10433",
    "95856"
  ],
  "./remixicon/editor/list-radio.svg": [
    "81440",
    "91202"
  ],
  "./remixicon/arrows/arrow-up-down-line.svg": [
    "10988",
    "82944"
  ],
  "./remixicon/design/scissors-cut-line.svg": [
    "37984",
    "40184"
  ],
  "./question-audio.svg": [
    "72490",
    "1920"
  ],
  "./remixicon/editor/text-snippet.svg": [
    "26272",
    "85788"
  ],
  "./remixicon/document/file-close-line.svg": [
    "4523",
    "30287"
  ],
  "./align-right.svg": [
    "42043",
    "62514"
  ],
  "./image-stack.svg": [
    "41682",
    "78223"
  ],
  "./remixicon/media/picture-in-picture-2-fill.svg": [
    "83564",
    "16624"
  ],
  "./task-bold.svg": [
    "27893",
    "86651"
  ],
  "./soc-twitter.svg": [
    "83913",
    "68710"
  ],
  "./remixicon/document/folder-warning-fill.svg": [
    "13752",
    "19304"
  ],
  "./save.svg": [
    "75708",
    "58276"
  ],
  "./caret-down.svg": [
    "76903",
    "93507"
  ],
  "./telegram.svg": [
    "2248",
    "16835"
  ],
  "./remixicon/document/file-info-line.svg": [
    "10654",
    "32021"
  ],
  "./warning-notify.svg": [
    "87932",
    "32069"
  ],
  "./plus-user.svg": [
    "9007",
    "45874"
  ],
  "./remixicon/arrows/arrow-up-double-line.svg": [
    "11518",
    "14017"
  ],
  "./bicolor/payments.svg": [
    "37330",
    "63423"
  ],
  "./remixicon/media/vidicon-fill.svg": [
    "77879",
    "87927"
  ],
  "./extensions/xlsx.svg": [
    "87862",
    "96651"
  ],
  "./arrow-left-round-2.svg": [
    "72128",
    "90765"
  ],
  "./brands/telegram.svg": [
    "27931",
    "19464"
  ],
  "./file-spreadsheet.svg": [
    "62934",
    "30694"
  ],
  "./bicolor/difficult-level-medium.svg": [
    "88337",
    "71789"
  ],
  "./chart-pie-alt.svg": [
    "51325",
    "12466"
  ],
  "./remixicon/arrows/arrow-drop-right-fill.svg": [
    "34798",
    "28506"
  ],
  "./remixicon/document/file-list-3-fill.svg": [
    "15895",
    "98404"
  ],
  "./remixicon/document/folder-6-line.svg": [
    "46177",
    "22064"
  ],
  "./bars-solid.svg": [
    "98106",
    "54772"
  ],
  "./email.svg": [
    "79918",
    "4649"
  ],
  "./eye-linethrough.svg": [
    "41181",
    "7711"
  ],
  "./eye.svg": [
    "41991",
    "25028"
  ],
  "./remixicon/arrows/corner-right-up-fill.svg": [
    "80861",
    "34942"
  ],
  "./remixicon/document/book-read-fill.svg": [
    "10328",
    "47392"
  ],
  "./remixicon/document/sticky-note-line.svg": [
    "84231",
    "88045"
  ],
  "./bubble-speak.svg": [
    "94749",
    "97912"
  ],
  "./remixicon/design/palette-fill.svg": [
    "92053",
    "33933"
  ],
  "./extensions/ps.svg": [
    "87801",
    "7346"
  ],
  "./remixicon/document/file-text-line.svg": [
    "9933",
    "43924"
  ],
  "./remixicon/document/folder-forbid-line.svg": [
    "91354",
    "50528"
  ],
  "./remixicon/arrows/expand-right-fill.svg": [
    "19291",
    "94133"
  ],
  "./remixicon/media/rewind-fill.svg": [
    "22053",
    "13888"
  ],
  "./remixicon/document/folder-download-fill.svg": [
    "53908",
    "61529"
  ],
  "./remixicon/media/skip-back-mini-line.svg": [
    "85100",
    "82417"
  ],
  "./remixicon/media/volume-mute-fill.svg": [
    "99508",
    "73142"
  ],
  "./remixicon/media/volume-off-vibrate-fill.svg": [
    "98483",
    "6174"
  ],
  "./remixicon/design/flip-vertical-fill.svg": [
    "38332",
    "56209"
  ],
  "./remixicon/media/camera-lens-line.svg": [
    "39179",
    "83991"
  ],
  "./remixicon/media/forward-30-line.svg": [
    "89453",
    "89663"
  ],
  "./remixicon/media/pause-circle-line.svg": [
    "19577",
    "26265"
  ],
  "./remixicon/editor/number-9.svg": [
    "11592",
    "15700"
  ],
  "./play-none.svg": [
    "16940",
    "26006"
  ],
  "./remixicon/editor/number-6.svg": [
    "28485",
    "71607"
  ],
  "./remixicon/media/forward-end-mini-line.svg": [
    "16922",
    "53203"
  ],
  "./remixicon/media/radio-2-fill.svg": [
    "94513",
    "88778"
  ],
  "./partner-business.svg": [
    "13371",
    "78827"
  ],
  "./rotate-clockwise.svg": [
    "44043",
    "87116"
  ],
  "./sand-clock.svg": [
    "86183",
    "31847"
  ],
  "./remixicon/document/todo-line.svg": [
    "50867",
    "15215"
  ],
  "./remixicon/arrows/expand-diagonal-2-fill.svg": [
    "63495",
    "42830"
  ],
  "./remixicon/document/file-ppt-2-fill.svg": [
    "42219",
    "70318"
  ],
  "./remixicon/media/notification-2-fill.svg": [
    "33248",
    "60917"
  ],
  "./remixicon/arrows/arrow-right-fill.svg": [
    "68089",
    "94865"
  ],
  "./remixicon/design/tools-line.svg": [
    "59040",
    "65964"
  ],
  "./share.svg": [
    "80570",
    "54098"
  ],
  "./sort-up.svg": [
    "64952",
    "80974"
  ],
  "./remixicon/document/file-reduce-fill.svg": [
    "56116",
    "5256"
  ],
  "./remixicon/design/layout-right-2-line.svg": [
    "10575",
    "41403"
  ],
  "./remixicon/arrows/drag-move-2-line.svg": [
    "68707",
    "45267"
  ],
  "./remixicon/arrows/drag-move-2-fill.svg": [
    "93828",
    "97714"
  ],
  "./remixicon/editor/send-to-back.svg": [
    "45387",
    "9664"
  ],
  "./remixicon/editor/text-direction-r.svg": [
    "73816",
    "38218"
  ],
  "./getting-certificate.svg": [
    "66768",
    "70683"
  ],
  "./remixicon/arrows/corner-up-left-line.svg": [
    "67134",
    "20784"
  ],
  "./logout.svg": [
    "26862",
    "78309"
  ],
  "./remixicon/editor/align-vertically.svg": [
    "73260",
    "87603"
  ],
  "./certificate.svg": [
    "21113",
    "92620"
  ],
  "./close-mini.svg": [
    "14847",
    "23068"
  ],
  "./remixicon/editor/merge-cells-vertical.svg": [
    "11862",
    "59426"
  ],
  "./remixicon/editor/space.svg": [
    "70003",
    "13733"
  ],
  "./notifications/main/team-check.svg": [
    "96894",
    "7765"
  ],
  "./remixicon/media/disc-fill.svg": [
    "42812",
    "70317"
  ],
  "./question-text.svg": [
    "36658",
    "16100"
  ],
  "./remixicon/design/layout-column-line.svg": [
    "8446",
    "17767"
  ],
  "./remixicon/document/file-pdf-2-fill.svg": [
    "56946",
    "10923"
  ],
  "./remixicon/document/folder-unknow-fill.svg": [
    "34602",
    "94962"
  ],
  "./partner-expert.svg": [
    "74238",
    "390"
  ],
  "./remixicon/document/file-line.svg": [
    "59846",
    "37957"
  ],
  "./remixicon/media/notification-off-line.svg": [
    "43226",
    "57486"
  ],
  "./remixicon/document/folder-received-fill.svg": [
    "93050",
    "1333"
  ],
  "./remixicon/arrows/arrow-drop-down-line.svg": [
    "21639",
    "43953"
  ],
  "./remixicon/media/polaroid-line.svg": [
    "1098",
    "81778"
  ],
  "./facebook.svg": [
    "54715",
    "71177"
  ],
  "./micro.svg": [
    "35455",
    "26713"
  ],
  "./remixicon/document/book-2-fill.svg": [
    "6105",
    "59525"
  ],
  "./notifications/bell-crossed.svg": [
    "79862",
    "804"
  ],
  "./center-text-alignment.svg": [
    "11122",
    "13533"
  ],
  "./refresh.svg": [
    "60871",
    "31743"
  ],
  "./remixicon/arrows/arrow-up-s-fill.svg": [
    "21041",
    "2877"
  ],
  "./remixicon/arrows/expand-diagonal-line.svg": [
    "83412",
    "26452"
  ],
  "./remixicon/editor/emphasis.svg": [
    "38973",
    "42544"
  ],
  "./remixicon/design/anticlockwise-line.svg": [
    "98249",
    "21133"
  ],
  "./remixicon/arrows/corner-up-right-double-line.svg": [
    "37301",
    "80830"
  ],
  "./remixicon/editor/timeline-view.svg": [
    "70791",
    "80798"
  ],
  "./remixicon/media/forward-5-line.svg": [
    "11272",
    "43169"
  ],
  "./remixicon/media/speed-up-fill.svg": [
    "44388",
    "79147"
  ],
  "./remixicon/media/voiceprint-line.svg": [
    "27898",
    "10649"
  ],
  "./remixicon/design/pencil-ruler-2-line.svg": [
    "43466",
    "56225"
  ],
  "./remixicon/design/layout-4-fill.svg": [
    "61461",
    "33171"
  ],
  "./attach.svg": [
    "18572",
    "40692"
  ],
  "./remixicon/arrows/arrow-up-circle-line.svg": [
    "7144",
    "70353"
  ],
  "./remixicon/arrows/arrow-right-s-line.svg": [
    "65959",
    "54971"
  ],
  "./remixicon/design/grid-fill.svg": [
    "19292",
    "86440"
  ],
  "./remixicon/design/paint-fill.svg": [
    "93849",
    "64512"
  ],
  "./remixicon/document/file-reduce-line.svg": [
    "57159",
    "96863"
  ],
  "./remixicon/document/survey-line.svg": [
    "41106",
    "78684"
  ],
  "./remixicon/document/file-2-line 2.svg": [
    "3836",
    "71487"
  ],
  "./search.svg": [
    "28075",
    "83458"
  ],
  "./remixicon/design/compasses-fill.svg": [
    "64884",
    "78921"
  ],
  "./remixicon/media/image-2-fill.svg": [
    "20450",
    "59564"
  ],
  "./remixicon/arrows/corner-left-down-line.svg": [
    "33533",
    "64053"
  ],
  "./remixicon/design/t-box-fill.svg": [
    "87998",
    "29413"
  ],
  "./triangle-arrow-down.svg": [
    "39166",
    "50649"
  ],
  "./remixicon/design/edit-2-line.svg": [
    "95588",
    "93237"
  ],
  "./remixicon/design/align-item-vertical-center-line.svg": [
    "61644",
    "42865"
  ],
  "./remixicon/arrows/skip-up-fill.svg": [
    "76011",
    "1642"
  ],
  "./remixicon/editor/number-3.svg": [
    "96957",
    "75994"
  ],
  "./remixicon/media/forward-end-line.svg": [
    "95388",
    "90769"
  ],
  "./remixicon/design/layout-masonry-line.svg": [
    "57074",
    "8349"
  ],
  "./remixicon/document/file-shield-2-line.svg": [
    "40926",
    "84635"
  ],
  "./recording.svg": [
    "72722",
    "84478"
  ],
  "./tablet.svg": [
    "24532",
    "80773"
  ],
  "./lesson-module-button.svg": [
    "850",
    "62742"
  ],
  "./remixicon/arrows/arrow-up-wide-line.svg": [
    "30451",
    "19869"
  ],
  "./remixicon/design/layout-left-2-fill.svg": [
    "21261",
    "78460"
  ],
  "./remixicon/design/pencil-fill.svg": [
    "84303",
    "77201"
  ],
  "./check-done-01.svg": [
    "4496",
    "51211"
  ],
  "./remixicon/document/file-user-line.svg": [
    "85156",
    "8149"
  ],
  "./remixicon/media/mic-2-line.svg": [
    "92790",
    "55121"
  ],
  "./remixicon/media/record-circle-fill.svg": [
    "48664",
    "64474"
  ],
  "./remixicon/arrows/contract-up-down-fill.svg": [
    "2909",
    "49292"
  ],
  "./bicolor/star.svg": [
    "53386",
    "75459"
  ],
  "./refresh-soft.svg": [
    "12266",
    "36640"
  ],
  "./remixicon/arrows/corner-right-down-fill.svg": [
    "17585",
    "61569"
  ],
  "./remixicon/document/folder-open-fill.svg": [
    "59837",
    "78929"
  ],
  "./copy.svg": [
    "80522",
    "8470"
  ],
  "./remixicon/editor/h-3.svg": [
    "4024",
    "38251"
  ],
  "./remixicon/document/file-word-2-fill.svg": [
    "1030",
    "35250"
  ],
  "./remixicon/media/gallery-fill.svg": [
    "94434",
    "526"
  ],
  "./remixicon/media/play-reverse-mini-fill.svg": [
    "33707",
    "67839"
  ],
  "./remixicon/media/video-download-line.svg": [
    "77999",
    "75005"
  ],
  "./remixicon/arrows/contract-right-line.svg": [
    "11766",
    "25198"
  ],
  "./google-map.svg": [
    "7209",
    "13511"
  ],
  "./remixicon/document/folder-3-line.svg": [
    "97081",
    "62054"
  ],
  "./remixicon/design/ink-bottle-fill.svg": [
    "63479",
    "69832"
  ],
  "./remixicon/document/file-2-fill.svg": [
    "47829",
    "13956"
  ],
  "./remixicon/document/file-shield-fill.svg": [
    "12000",
    "33833"
  ],
  "./remixicon/editor/superscript-2.svg": [
    "54662",
    "99928"
  ],
  "./remixicon/media/skip-back-mini-fill.svg": [
    "213",
    "52503"
  ],
  "./open-book.svg": [
    "64482",
    "65647"
  ],
  "./timer.svg": [
    "52695",
    "24178"
  ],
  "./remixicon/media/notification-line.svg": [
    "7998",
    "72588"
  ],
  "./remixicon/media/notification-4-fill.svg": [
    "63326",
    "44619"
  ],
  "./test-bold.svg": [
    "95959",
    "13238"
  ],
  "./callout-important.svg": [
    "49552",
    "73798"
  ],
  "./learning-role.svg": [
    "70882",
    "84420"
  ],
  "./remixicon/media/dvd-line.svg": [
    "81326",
    "41845"
  ],
  "./remixicon/design/layout-fill.svg": [
    "67090",
    "421"
  ],
  "./remixicon/media/aspect-ratio-fill.svg": [
    "52906",
    "25962"
  ],
  "./remixicon/arrows/drag-move-line.svg": [
    "73576",
    "1862"
  ],
  "./remixicon/arrows/arrow-down-wide-line.svg": [
    "26770",
    "58293"
  ],
  "./remixicon/document/file-upload-line.svg": [
    "23281",
    "99430"
  ],
  "./book-role.svg": [
    "3698",
    "14423"
  ],
  "./remixicon/document/folder-zip-line.svg": [
    "47356",
    "70458"
  ],
  "./dots.svg": [
    "76326",
    "56224"
  ],
  "./remixicon/document/file-shred-line.svg": [
    "86726",
    "10896"
  ],
  "./page.svg": [
    "24810",
    "73885"
  ],
  "./remixicon/document/folder-received-line.svg": [
    "27409",
    "33685"
  ],
  "./remixicon/media/speed-mini-fill.svg": [
    "18444",
    "79483"
  ],
  "./remixicon/editor/link-unlink-m.svg": [
    "63039",
    "23360"
  ],
  "./settings-outline.svg": [
    "4081",
    "22472"
  ],
  "./unlinked.svg": [
    "71309",
    "62293"
  ],
  "./remixicon/design/contrast-fill.svg": [
    "81371",
    "56480"
  ],
  "./verification-check.svg": [
    "33590",
    "22049"
  ],
  "./chat.svg": [
    "4408",
    "31458"
  ],
  "./info-round.svg": [
    "15733",
    "1275"
  ],
  "./remixicon/media/camera-2-line.svg": [
    "42490",
    "82164"
  ],
  "./remixicon/arrows/arrow-down-double-fill.svg": [
    "5645",
    "98999"
  ],
  "./remixicon/design/brush-line.svg": [
    "44537",
    "90539"
  ],
  "./remixicon/media/play-list-add-fill.svg": [
    "37683",
    "46066"
  ],
  "./remixicon/design/layout-grid-2-line.svg": [
    "58404",
    "63337"
  ],
  "./angle-right-fill.svg": [
    "94177",
    "85037"
  ],
  "./remixicon/design/ruler-fill.svg": [
    "64462",
    "90641"
  ],
  "./remixicon/media/play-list-add-line.svg": [
    "51689",
    "34946"
  ],
  "./remixicon/document/folder-image-line.svg": [
    "91460",
    "23094"
  ],
  "./profile.svg": [
    "17531",
    "99857"
  ],
  "./remixicon/media/volume-mute-line.svg": [
    "78665",
    "92564"
  ],
  "./online-learning.svg": [
    "22255",
    "18090"
  ],
  "./question-arrange-words.svg": [
    "28758",
    "46571"
  ],
  "./remixicon/editor/omega.svg": [
    "86485",
    "48749"
  ],
  "./remixicon/media/picture-in-picture-fill.svg": [
    "40828",
    "39145"
  ],
  "./remixicon/document/folder-settings-line.svg": [
    "51446",
    "90920"
  ],
  "./remixicon/arrows/arrow-up-s-line.svg": [
    "46994",
    "18876"
  ],
  "./remixicon/editor/quote-text.svg": [
    "52927",
    "37794"
  ],
  "./comment1.svg": [
    "15845",
    "77035"
  ],
  "./remixicon/media/rewind-start-fill.svg": [
    "9175",
    "54290"
  ],
  "./remixicon/design/input-method-fill.svg": [
    "65588",
    "98530"
  ],
  "./remixicon/media/video-on-line.svg": [
    "94677",
    "90180"
  ],
  "./video.svg": [
    "61535",
    "1151"
  ],
  "./remixicon/editor/text-block.svg": [
    "31836",
    "88379"
  ],
  "./twitter.svg": [
    "74468",
    "1705"
  ],
  "./remixicon/editor/h-1.svg": [
    "16401",
    "54553"
  ],
  "./remixicon/document/file-chart-2-fill.svg": [
    "98087",
    "46681"
  ],
  "./remixicon/document/file-check-fill.svg": [
    "98531",
    "53217"
  ],
  "./remixicon/design/layout-2-line.svg": [
    "68117",
    "95231"
  ],
  "./remixicon/document/file-settings-fill.svg": [
    "93736",
    "1304"
  ],
  "./remixicon/document/file-marked-fill.svg": [
    "93570",
    "3906"
  ],
  "./remixicon/media/equalizer-line.svg": [
    "13060",
    "39099"
  ],
  "./remixicon/design/triangle-line.svg": [
    "55805",
    "28750"
  ],
  "./remixicon/arrows/corner-left-up-fill.svg": [
    "69842",
    "41640"
  ],
  "./remixicon/document/file-history-line.svg": [
    "74153",
    "4680"
  ],
  "./remixicon/editor/formula.svg": [
    "44466",
    "44662"
  ],
  "./multiple.svg": [
    "52236",
    "75830"
  ],
  "./add-template-select.svg": [
    "73599",
    "39731"
  ],
  "./remixicon/media/play-line.svg": [
    "80948",
    "96972"
  ],
  "./lesson-module-file.svg": [
    "62537",
    "7544"
  ],
  "./remixicon/editor/pinyin-input.svg": [
    "78130",
    "18633"
  ],
  "./notifications/main/add-payment.svg": [
    "42728",
    "14645"
  ],
  "./remixicon/editor/superscript.svg": [
    "96425",
    "70992"
  ],
  "./remixicon/media/memories-fill.svg": [
    "22453",
    "97285"
  ],
  "./remixicon/editor/functions.svg": [
    "10589",
    "34356"
  ],
  "./verify-pending.svg": [
    "32088",
    "95999"
  ],
  "./remixicon/document/file-gif-fill.svg": [
    "61260",
    "23828"
  ],
  "./remixicon/document/folder-line.svg": [
    "77150",
    "84295"
  ],
  "./time-add.svg": [
    "77014",
    "10198"
  ],
  "./remixicon/design/pencil-ruler-line.svg": [
    "99298",
    "93630"
  ],
  "./attention.svg": [
    "87282",
    "25520"
  ],
  "./notifications/status/add-circle.svg": [
    "63705",
    "98356"
  ],
  "./remixicon/editor/split-cells-vertical.svg": [
    "55263",
    "65753"
  ],
  "./square-code-role.svg": [
    "19213",
    "76512"
  ],
  "./lesson-module-video.svg": [
    "7751",
    "82112"
  ],
  "./remixicon/arrows/collapse-diagonal-line.svg": [
    "25489",
    "59495"
  ],
  "./remixicon/arrows/skip-down-line.svg": [
    "77394",
    "6273"
  ],
  "./remixicon/design/paint-brush-line.svg": [
    "79631",
    "73208"
  ],
  "./remixicon/editor/h-2.svg": [
    "22465",
    "36737"
  ],
  "./remixicon/media/rewind-start-line.svg": [
    "1562",
    "81074"
  ],
  "./remixicon/editor/heading.svg": [
    "4492",
    "90594"
  ],
  "./chest.svg": [
    "11541",
    "10271"
  ],
  "./logout-rounded.svg": [
    "57732",
    "76144"
  ],
  "./remixicon/design/pen-nib-fill.svg": [
    "72186",
    "90961"
  ],
  "./remixicon/media/speaker-3-fill.svg": [
    "46402",
    "37960"
  ],
  "./remixicon/design/layout-4-line.svg": [
    "97855",
    "61144"
  ],
  "./remixicon/document/clipboard-line.svg": [
    "55886",
    "14296"
  ],
  "./remixicon/editor/font-sans.svg": [
    "60657",
    "93899"
  ],
  "./remixicon/media/fullscreen-exit-line.svg": [
    "2647",
    "67189"
  ],
  "./envelope-plus.svg": [
    "32240",
    "9630"
  ],
  "./users-plus.svg": [
    "31086",
    "92736"
  ],
  "./remixicon/media/skip-forward-line.svg": [
    "59354",
    "41955"
  ],
  "./remixicon/arrows/arrow-right-line.svg": [
    "39350",
    "97489"
  ],
  "./notification.svg": [
    "18968",
    "75189"
  ],
  "./remixicon/media/vidicon-line.svg": [
    "50970",
    "18228"
  ],
  "./remixicon/arrows/arrow-left-wide-fill.svg": [
    "97631",
    "8421"
  ],
  "./notifications/bell-with-circle.svg": [
    "35636",
    "2626"
  ],
  "./text-reset.svg": [
    "31215",
    "64329"
  ],
  "./hourglass.svg": [
    "5581",
    "64997"
  ],
  "./clock-course.svg": [
    "94458",
    "39868"
  ],
  "./remixicon/editor/square-root.svg": [
    "68791",
    "75121"
  ],
  "./remixicon/media/camera-3-fill.svg": [
    "3163",
    "26696"
  ],
  "./remixicon/editor/table-3.svg": [
    "70486",
    "16687"
  ],
  "./question-select.svg": [
    "97275",
    "16902"
  ],
  "./plan-business.svg": [
    "3631",
    "93125"
  ],
  "./send.svg": [
    "37024",
    "80098"
  ],
  "./remixicon/media/play-circle-fill.svg": [
    "61820",
    "88288"
  ],
  "./remixicon/design/clockwise-line.svg": [
    "38092",
    "58856"
  ],
  "./remixicon/design/square-fill.svg": [
    "81208",
    "71056"
  ],
  "./editing-pen.svg": [
    "95270",
    "84283"
  ],
  "./remixicon/design/layout-column-fill.svg": [
    "59232",
    "21850"
  ],
  "./settings-thin.svg": [
    "38426",
    "29795"
  ],
  "./remixicon/media/vidicon-2-fill.svg": [
    "42722",
    "74839"
  ],
  "./arrow-up.svg": [
    "92224",
    "53147"
  ],
  "./remixicon/document/sticky-note-2-fill 2.svg": [
    "46339",
    "33757"
  ],
  "./remixicon/design/collage-fill.svg": [
    "26025",
    "29695"
  ],
  "./remixicon/document/sticky-note-2-line.svg": [
    "73687",
    "60398"
  ],
  "./direction-signal.svg": [
    "71586",
    "29390"
  ],
  "./remixicon/document/contacts-book-3-line.svg": [
    "42241",
    "19198"
  ],
  "./remixicon/design/crop-2-line.svg": [
    "96603",
    "91693"
  ],
  "./soc-telegram-sharp.svg": [
    "90385",
    "6166"
  ],
  "./remixicon/document/file-hwp-fill.svg": [
    "10498",
    "10657"
  ],
  "./remixicon/document/contract-line.svg": [
    "26771",
    "33233"
  ],
  "./comment.svg": [
    "49022",
    "88525"
  ],
  "./diploma-role.svg": [
    "28286",
    "36316"
  ],
  "./brands/skillspace.svg": [
    "47332",
    "19587"
  ],
  "./remixicon/arrows/arrow-drop-right-line.svg": [
    "95057",
    "20828"
  ],
  "./remixicon/document/folder-keyhole-line.svg": [
    "54405",
    "7309"
  ],
  "./remixicon/editor/number-5.svg": [
    "7030",
    "77954"
  ],
  "./remixicon/editor/paragraph.svg": [
    "2818",
    "72414"
  ],
  "./remixicon/document/folder-video-line.svg": [
    "58910",
    "47604"
  ],
  "./remixicon/editor/sort-desc.svg": [
    "88373",
    "76524"
  ],
  "./remixicon/arrows/arrow-up-down-fill.svg": [
    "43402",
    "13387"
  ],
  "./remixicon/media/equalizer-fill.svg": [
    "5218",
    "81266"
  ],
  "./rounded-up.svg": [
    "51677",
    "20478"
  ],
  "./remixicon/design/ball-pen-fill.svg": [
    "72453",
    "24807"
  ],
  "./remixicon/document/folder-shared-fill.svg": [
    "33160",
    "18414"
  ],
  "./arrow-insert-circle.svg": [
    "5554",
    "26678"
  ],
  "./angle-down.svg": [
    "33585",
    "1545"
  ],
  "./remixicon/arrows/arrow-up-line.svg": [
    "61759",
    "28642"
  ],
  "./betta.svg": [
    "32312",
    "9212"
  ],
  "./remixicon/document/folder-shield-2-line.svg": [
    "45221",
    "80361"
  ],
  "./remixicon/document/pages-fill.svg": [
    "61668",
    "90335"
  ],
  "./remixicon/design/layout-bottom-2-line.svg": [
    "1673",
    "98243"
  ],
  "./chart.svg": [
    "23050",
    "3946"
  ],
  "./phone-circle.svg": [
    "15740",
    "17582"
  ],
  "./remixicon/arrows/arrow-left-right-line.svg": [
    "7063",
    "52417"
  ],
  "./remixicon/document/file-damage-line.svg": [
    "95708",
    "72694"
  ],
  "./remixicon/document/book-open-line.svg": [
    "23648",
    "52701"
  ],
  "./remixicon/document/clipboard-fill.svg": [
    "47580",
    "9232"
  ],
  "./remixicon/arrows/arrow-left-double-fill.svg": [
    "23827",
    "38731"
  ],
  "./calendar-check.svg": [
    "46429",
    "12961"
  ],
  "./notifications/notification.svg": [
    "57829",
    "33641"
  ],
  "./questInfo.svg": [
    "37743",
    "88874"
  ],
  "./editor-role.svg": [
    "23904",
    "76835"
  ],
  "./remixicon/arrows/collapse-diagonal-2-line.svg": [
    "35522",
    "12487"
  ],
  "./remixicon/document/file-word-2-line.svg": [
    "34824",
    "57015"
  ],
  "./remixicon/document/folders-line.svg": [
    "42109",
    "45142"
  ],
  "./extensions/archive.svg": [
    "86618",
    "32272"
  ],
  "./lesson-module-image.svg": [
    "98066",
    "66504"
  ],
  "./remixicon/media/slow-down-fill.svg": [
    "71838",
    "40584"
  ],
  "./remixicon/design/flip-horizontal-fill.svg": [
    "81467",
    "30441"
  ],
  "./remixicon/editor/send-backward.svg": [
    "92094",
    "41371"
  ],
  "./bicolor/homeworks.svg": [
    "13957",
    "69513"
  ],
  "./remixicon/design/edit-circle-line.svg": [
    "47670",
    "72978"
  ],
  "./remixicon/media/stop-fill.svg": [
    "33179",
    "644"
  ],
  "./remixicon/document/file-4-line.svg": [
    "54097",
    "32845"
  ],
  "./cloud-plus.svg": [
    "72916",
    "8191"
  ],
  "./remixicon/media/play-fill.svg": [
    "55294",
    "84067"
  ],
  "./move.svg": [
    "52338",
    "6899"
  ],
  "./remixicon/document/file-video-fill.svg": [
    "61303",
    "12089"
  ],
  "./remixicon/document/file-list-line.svg": [
    "16791",
    "46340"
  ],
  "./remixicon/media/polaroid-2-line.svg": [
    "60049",
    "17772"
  ],
  "./remixicon/media/replay-5-line.svg": [
    "54224",
    "49485"
  ],
  "./sort-down.svg": [
    "63664",
    "45553"
  ],
  "./remixicon/design/layout-bottom-line.svg": [
    "90735",
    "93704"
  ],
  "./remixicon/document/folder-info-line.svg": [
    "11404",
    "34104"
  ],
  "./settings-sliders.svg": [
    "67863",
    "88894"
  ],
  "./remixicon/editor/number-4.svg": [
    "51098",
    "33739"
  ],
  "./remixicon/media/broadcast-fill.svg": [
    "34290",
    "28670"
  ],
  "./remixicon/arrows/arrow-right-wide-fill.svg": [
    "65853",
    "22034"
  ],
  "./remixicon/document/folder-warning-line.svg": [
    "8371",
    "55859"
  ],
  "./remixicon/arrows/skip-right-line.svg": [
    "27814",
    "60215"
  ],
  "./soc-facebook.svg": [
    "66694",
    "69050"
  ],
  "./notifications/main/webcam.svg": [
    "72088",
    "86380"
  ],
  "./stretch.svg": [
    "80860",
    "78233"
  ],
  "./close-line.svg": [
    "88211",
    "38593"
  ],
  "./remixicon/media/hd-fill.svg": [
    "4551",
    "73623"
  ],
  "./squares.svg": [
    "65906",
    "7104"
  ],
  "./remixicon/design/blur-off-fill.svg": [
    "70775",
    "41983"
  ],
  "./verify-done.svg": [
    "48798",
    "19670"
  ],
  "./notifications/status/cross-circle.svg": [
    "50483",
    "8464"
  ],
  "./drag-block.svg": [
    "6117",
    "67114"
  ],
  "./block-line.svg": [
    "84637",
    "37486"
  ],
  "./remixicon/media/camera-fill.svg": [
    "78125",
    "81946"
  ],
  "./remixicon/media/replay-10-fill.svg": [
    "69570",
    "63931"
  ],
  "./remixicon/media/mic-off-line.svg": [
    "48489",
    "96429"
  ],
  "./remixicon/editor/line-height.svg": [
    "40461",
    "73042"
  ],
  "./bicolor/settings.svg": [
    "73597",
    "31733"
  ],
  "./remixicon/document/file-settings-line.svg": [
    "7869",
    "58061"
  ],
  "./youtube.svg": [
    "6472",
    "1640"
  ],
  "./plus-thin.svg": [
    "56761",
    "70836"
  ],
  "./angle-left.svg": [
    "3264",
    "48484"
  ],
  "./left-arrow.svg": [
    "42439",
    "42165"
  ],
  "./check-circle1.svg": [
    "10107",
    "77246"
  ],
  "./cross-circle.svg": [
    "95115",
    "32905"
  ],
  "./users-role.svg": [
    "91987",
    "82057"
  ],
  "./remixicon/editor/link-m.svg": [
    "37718",
    "87123"
  ],
  "./remixicon/document/folder-lock-fill.svg": [
    "70019",
    "86832"
  ],
  "./remixicon/editor/format-clear.svg": [
    "66577",
    "44243"
  ],
  "./remixicon/document/file-shield-2-fill.svg": [
    "42394",
    "77515"
  ],
  "./image.svg": [
    "68003",
    "64070"
  ],
  "./remixicon/document/pages-line.svg": [
    "78045",
    "36914"
  ],
  "./remixicon/editor/font-color.svg": [
    "60208",
    "16232"
  ],
  "./remixicon/media/music-2-line.svg": [
    "83989",
    "41449"
  ],
  "./remixicon/media/surround-sound-fill.svg": [
    "9482",
    "2659"
  ],
  "./remixicon/arrows/corner-right-down-line.svg": [
    "19649",
    "84825"
  ],
  "./remixicon/design/paint-brush-fill.svg": [
    "4581",
    "20735"
  ],
  "./remixicon/document/file-copy-2-line.svg": [
    "4282",
    "5273"
  ],
  "./remixicon/media/video-off-fill.svg": [
    "63612",
    "17776"
  ],
  "./remixicon/media/fullscreen-line.svg": [
    "50543",
    "35209"
  ],
  "./remixicon/design/focus-line.svg": [
    "91798",
    "90825"
  ],
  "./save-table.svg": [
    "84458",
    "33181"
  ],
  "./success-notify.svg": [
    "53879",
    "37884"
  ],
  "./remixicon/media/vidicon-2-line.svg": [
    "92201",
    "93929"
  ],
  "./remixicon/design/pen-nib-line.svg": [
    "43122",
    "24055"
  ],
  "./double-message.svg": [
    "8409",
    "16836"
  ],
  "./remixicon/document/folder-chart-line.svg": [
    "46338",
    "2996"
  ],
  "./remixicon/design/compasses-2-fill.svg": [
    "57328",
    "85790"
  ],
  "./remixicon/document/article-fill.svg": [
    "75120",
    "75889"
  ],
  "./remixicon/document/book-read-line.svg": [
    "337",
    "31230"
  ],
  "./remixicon/design/layout-row-line.svg": [
    "85875",
    "53883"
  ],
  "./remixicon/document/folder-open-line.svg": [
    "52789",
    "8586"
  ],
  "./remixicon/editor/attachment-2.svg": [
    "20789",
    "84692"
  ],
  "./remixicon/editor/input-cursor-move.svg": [
    "45064",
    "24955"
  ],
  "./remixicon/arrows/arrow-right-s-fill.svg": [
    "35384",
    "48473"
  ],
  "./remixicon/design/layout-grid-line.svg": [
    "86659",
    "27444"
  ],
  "./remixicon/media/camera-off-fill.svg": [
    "12568",
    "95462"
  ],
  "./remixicon/editor/underline.svg": [
    "47374",
    "19065"
  ],
  "./remixicon/editor/asterisk.svg": [
    "17576",
    "80968"
  ],
  "./remixicon/media/notification-3-line.svg": [
    "60231",
    "19006"
  ],
  "./soc-youtube.svg": [
    "32800",
    "51887"
  ],
  "./remixicon/document/contacts-book-upload-line.svg": [
    "3158",
    "79629"
  ],
  "./remixicon/document/file-search-fill.svg": [
    "59492",
    "55145"
  ],
  "./settings.svg": [
    "64258",
    "2179"
  ],
  "./star-role.svg": [
    "46553",
    "52431"
  ],
  "./time-past.svg": [
    "78597",
    "30584"
  ],
  "./remixicon/media/speaker-line.svg": [
    "34109",
    "80514"
  ],
  "./remixicon/arrows/expand-right-line.svg": [
    "18890",
    "52419"
  ],
  "./remixicon/design/ball-pen-line.svg": [
    "83048",
    "7714"
  ],
  "./remixicon/document/file-forbid-fill.svg": [
    "95567",
    "16604"
  ],
  "./engine-warning.svg": [
    "53881",
    "17581"
  ],
  "./flip-vertical.svg": [
    "64211",
    "22987"
  ],
  "./remixicon/media/disc-line.svg": [
    "39169",
    "3311"
  ],
  "./remixicon/editor/number-7.svg": [
    "726",
    "10402"
  ],
  "./clip.svg": [
    "3804",
    "91138"
  ],
  "./remixicon/media/hq-fill.svg": [
    "64217",
    "52330"
  ],
  "./extensions/audio.svg": [
    "40982",
    "8488"
  ],
  "./remixicon/design/flip-horizontal-2-line.svg": [
    "3545",
    "94302"
  ],
  "./right-landscape-first-loopers.svg": [
    "95737",
    "22332"
  ],
  "./remixicon/design/contrast-line.svg": [
    "99598",
    "93825"
  ],
  "./lock4.svg": [
    "6943",
    "17680"
  ],
  "./cloud-error.svg": [
    "1235",
    "3631"
  ],
  "./remixicon/design/paint-line.svg": [
    "43013",
    "15251"
  ],
  "./remixicon/media/movie-2-fill.svg": [
    "5774",
    "63848"
  ],
  "./check-circle.svg": [
    "59118",
    "71932"
  ],
  "./remixicon/design/layout-2-fill.svg": [
    "19108",
    "11542"
  ],
  "./verify-decline.svg": [
    "68965",
    "83482"
  ],
  "./remixicon/media/film-line.svg": [
    "81525",
    "70712"
  ],
  "./remixicon/design/pencil-ruler-fill.svg": [
    "70585",
    "7117"
  ],
  "./brands/apple.svg": [
    "89069",
    "97395"
  ],
  "./check-round-2.svg": [
    "52427",
    "83477"
  ],
  "./remixicon/design/compasses-2-line.svg": [
    "91055",
    "31675"
  ],
  "./remixicon/design/edit-2-fill.svg": [
    "13784",
    "93377"
  ],
  "./remixicon/editor/bring-forward.svg": [
    "79120",
    "7158"
  ],
  "./send-2.svg": [
    "30482",
    "31239"
  ],
  "./remixicon/document/task-fill.svg": [
    "75769",
    "21283"
  ],
  "./remixicon/design/rectangle-line.svg": [
    "26391",
    "15856"
  ],
  "./remixicon/media/picture-in-picture-exit-line.svg": [
    "37000",
    "60502"
  ],
  "./remixicon/document/folder-5-fill.svg": [
    "28450",
    "63707"
  ],
  "./chart-histogram-role.svg": [
    "10163",
    "67065"
  ],
  "./remixicon/editor/hand.svg": [
    "88777",
    "3578"
  ],
  "./fair.svg": [
    "29038",
    "18906"
  ],
  "./remixicon/arrows/contract-left-fill.svg": [
    "65354",
    "36090"
  ],
  "./remixicon/editor/kanban-view.svg": [
    "13316",
    "21225"
  ],
  "./arrow-right-round-2.svg": [
    "95449",
    "52481"
  ],
  "./remixicon/arrows/arrow-left-circle-line.svg": [
    "72847",
    "24584"
  ],
  "./arrow-right-long.svg": [
    "6283",
    "9142"
  ],
  "./remixicon/editor/insert-row-bottom.svg": [
    "56154",
    "25044"
  ],
  "./remixicon/media/forward-end-fill.svg": [
    "35922",
    "46127"
  ],
  "./soc-facebook-round.svg": [
    "31115",
    "83249"
  ],
  "./remixicon/arrows/arrow-right-circle-fill.svg": [
    "30594",
    "51938"
  ],
  "./soc-instagram.svg": [
    "51022",
    "19666"
  ],
  "./remixicon/design/align-item-horizontal-center-fill.svg": [
    "54722",
    "23674"
  ],
  "./help.svg": [
    "7253",
    "80356"
  ],
  "./remixicon/arrows/arrow-left-s-fill.svg": [
    "69574",
    "22880"
  ],
  "./passed-stars.svg": [
    "55626",
    "78592"
  ],
  "./remixicon/editor/double-quotes-r.svg": [
    "76842",
    "76876"
  ],
  "./remixicon/editor/number-0.svg": [
    "68244",
    "98810"
  ],
  "./hourglass-end.svg": [
    "13378",
    "47674"
  ],
  "./remixicon/media/shuffle-fill.svg": [
    "40959",
    "49185"
  ],
  "./align-left.svg": [
    "85818",
    "89096"
  ],
  "./email-plus.svg": [
    "34968",
    "53724"
  ],
  "./remixicon/media/skip-back-line.svg": [
    "89566",
    "14731"
  ],
  "./remixicon/arrows/arrow-turn-back-line.svg": [
    "18488",
    "4410"
  ],
  "./remixicon/media/sound-module-fill.svg": [
    "87442",
    "30762"
  ],
  "./notifications/main/ticket.svg": [
    "58994",
    "65476"
  ],
  "./remixicon/design/focus-fill.svg": [
    "56145",
    "62213"
  ],
  "./remixicon/document/file-image-fill.svg": [
    "32086",
    "21018"
  ],
  "./logo-mosru.svg": [
    "84438",
    "36359"
  ],
  "./audio.svg": [
    "25859",
    "36226"
  ],
  "./remixicon/design/pencil-line.svg": [
    "42397",
    "39581"
  ],
  "./cloud-ok.svg": [
    "67175",
    "7898"
  ],
  "./remixicon/design/anticlockwise-2-line.svg": [
    "94682",
    "93616"
  ],
  "./remixicon/design/quill-pen-line.svg": [
    "10943",
    "89836"
  ],
  "./remixicon/design/scissors-2-line.svg": [
    "84834",
    "46653"
  ],
  "./remixicon/design/layout-top-2-fill.svg": [
    "91067",
    "62338"
  ],
  "./remixicon/arrows/arrow-right-double-fill.svg": [
    "64395",
    "36856"
  ],
  "./remixicon/document/keynote-line.svg": [
    "51447",
    "80871"
  ],
  "./remixicon/editor/carousel-view.svg": [
    "81251",
    "71904"
  ],
  "./remixicon/media/order-play-fill.svg": [
    "64927",
    "2747"
  ],
  "./remixicon/arrows/arrow-down-circle-fill 2.svg": [
    "21423",
    "9162"
  ],
  "./remixicon/design/table-fill.svg": [
    "66228",
    "88740"
  ],
  "./remixicon/document/folder-transfer-fill.svg": [
    "27166",
    "27947"
  ],
  "./remixicon/media/album-line.svg": [
    "25631",
    "37676"
  ],
  "./remixicon/media/pause-large-fill.svg": [
    "405",
    "81606"
  ],
  "./align-center.svg": [
    "40641",
    "71002"
  ],
  "./triangle-up.svg": [
    "89430",
    "74682"
  ],
  "./remixicon/design/drag-drop-line.svg": [
    "40359",
    "35964"
  ],
  "./remixicon/design/pencil-ruler-2-fill.svg": [
    "2612",
    "71134"
  ],
  "./two-link.svg": [
    "63066",
    "79853"
  ],
  "./accessSetting.svg": [
    "28881",
    "40612"
  ],
  "./remixicon/document/folder-2-line.svg": [
    "25108",
    "27550"
  ],
  "./notifications/main/spid-clock.svg": [
    "76826",
    "31565"
  ],
  "./bicolor/difficult-level-high.svg": [
    "57230",
    "91408"
  ],
  "./link.svg": [
    "49120",
    "51803"
  ],
  "./remixicon/document/folder-reduce-line.svg": [
    "78277",
    "35996"
  ],
  "./remixicon/media/mic-line.svg": [
    "78059",
    "82068"
  ],
  "./play-button.svg": [
    "82253",
    "6010"
  ],
  "./remixicon/design/edit-line.svg": [
    "125",
    "11992"
  ],
  "./plus-round-divided.svg": [
    "54657",
    "13498"
  ],
  "./shuffle.svg": [
    "90648",
    "36811"
  ],
  "./remixicon/design/triangle-fill.svg": [
    "81474",
    "60433"
  ],
  "./remixicon/editor/sort-number-desc.svg": [
    "59919",
    "86608"
  ],
  "./remixicon/arrows/expand-width-fill.svg": [
    "83723",
    "613"
  ],
  "./dislike.svg": [
    "9302",
    "53541"
  ],
  "./remixicon/arrows/arrow-turn-back-fill.svg": [
    "52043",
    "32544"
  ],
  "./remixicon/design/hexagon-fill.svg": [
    "1347",
    "95218"
  ],
  "./arrow-right-circle.svg": [
    "30628",
    "90087"
  ],
  "./remixicon/design/shape-2-line.svg": [
    "53129",
    "13218"
  ],
  "./remixicon/design/mark-pen-fill.svg": [
    "31701",
    "43613"
  ],
  "./remixicon/editor/sort-asc.svg": [
    "41605",
    "17170"
  ],
  "./remixicon/editor/sort-alphabet-desc.svg": [
    "56219",
    "4568"
  ],
  "./remixicon/document/file-history-fill.svg": [
    "47061",
    "87275"
  ],
  "./remixicon/editor/text-spacing.svg": [
    "75027",
    "20808"
  ],
  "./remixicon/media/4k-line.svg": [
    "29966",
    "34969"
  ],
  "./remixicon/media/replay-5-fill.svg": [
    "81014",
    "19250"
  ],
  "./remixicon/design/pantone-fill.svg": [
    "15854",
    "73318"
  ],
  "./remixicon/design/align-item-top-line.svg": [
    "37790",
    "52731"
  ],
  "./remixicon/arrows/arrow-drop-up-line.svg": [
    "60151",
    "71710"
  ],
  "./remixicon/design/compasses-line.svg": [
    "9736",
    "9689"
  ],
  "./remixicon/design/flip-vertical-line.svg": [
    "23495",
    "98957"
  ],
  "./remixicon/editor/text-direction-l.svg": [
    "28024",
    "55781"
  ],
  "./notifications/main/hexagon-exclamation.svg": [
    "62612",
    "80643"
  ],
  "./cloud.svg": [
    "1998",
    "34130"
  ],
  "./badge-check.svg": [
    "37410",
    "40667"
  ],
  "./card-simple.svg": [
    "20629",
    "56936"
  ],
  "./remixicon/editor/h-5.svg": [
    "82569",
    "70895"
  ],
  "./remixicon/editor/heading 2.svg": [
    "34032",
    "37569"
  ],
  "./remixicon/document/contacts-book-fill.svg": [
    "59911",
    "24597"
  ],
  "./remixicon/editor/number-1.svg": [
    "80595",
    "24352"
  ],
  "./remixicon/media/camera-2-fill.svg": [
    "74767",
    "36227"
  ],
  "./code.svg": [
    "56630",
    "16641"
  ],
  "./link-external.svg": [
    "50255",
    "75135"
  ],
  "./remixicon/design/layout-5-fill.svg": [
    "97698",
    "54140"
  ],
  "./close.svg": [
    "80436",
    "2078"
  ],
  "./folder-upload.svg": [
    "29535",
    "46367"
  ],
  "./notifications/notification-redirect.svg": [
    "5215",
    "21040"
  ],
  "./remixicon/arrows/skip-right-fill.svg": [
    "51516",
    "98035"
  ],
  "./remixicon/design/anticlockwise-2-fill.svg": [
    "11652",
    "79939"
  ],
  "./remixicon/document/file-check-line.svg": [
    "65196",
    "26022"
  ],
  "./remixicon/document/file-gif-line.svg": [
    "98369",
    "474"
  ],
  "./remixicon/document/file-music-line.svg": [
    "22607",
    "15165"
  ],
  "./remixicon/document/folder-5-line.svg": [
    "96239",
    "51907"
  ],
  "./remixicon/editor/english-input.svg": [
    "5335",
    "20186"
  ],
  "./remixicon/design/clockwise-fill.svg": [
    "88393",
    "73865"
  ],
  "./lock.svg": [
    "49586",
    "88197"
  ],
  "./remixicon/editor/font-mono.svg": [
    "37053",
    "82994"
  ],
  "./dots-menu.svg": [
    "57925",
    "71016"
  ],
  "./extensions/pp.svg": [
    "64487",
    "38532"
  ],
  "./course-unpublished.svg": [
    "58820",
    "83764"
  ],
  "./graduation-cap-bold.svg": [
    "68258",
    "64055"
  ],
  "./remixicon/document/folder-shield-2-fill.svg": [
    "39560",
    "65835"
  ],
  "./remixicon/arrows/corner-left-down-fill.svg": [
    "67604",
    "44480"
  ],
  "./remixicon/media/eject-line.svg": [
    "13110",
    "81613"
  ],
  "./remixicon/media/phone-camera-fill.svg": [
    "96775",
    "52198"
  ],
  "./remixicon/media/video-upload-line.svg": [
    "84999",
    "23074"
  ],
  "./remixicon/document/draft-line.svg": [
    "46781",
    "85887"
  ],
  "./remixicon/media/volume-up-fill.svg": [
    "82590",
    "52050"
  ],
  "./time-forward.svg": [
    "10140",
    "6715"
  ],
  "./zoom-in.svg": [
    "64910",
    "17420"
  ],
  "./remixicon/media/gallery-line.svg": [
    "41755",
    "61603"
  ],
  "./remixicon/media/play-circle-line.svg": [
    "11457",
    "53561"
  ],
  "./remixicon/arrows/arrow-go-forward-line.svg": [
    "63912",
    "41856"
  ],
  "./remixicon/media/slow-down-line.svg": [
    "68603",
    "59271"
  ],
  "./remixicon/design/contrast-drop-line.svg": [
    "85996",
    "15840"
  ],
  "./remixicon/design/layout-horizontal-line.svg": [
    "86514",
    "58879"
  ],
  "./question-fill-words.svg": [
    "96400",
    "74741"
  ],
  "./long-arrow-left.svg": [
    "78760",
    "55367"
  ],
  "./remixicon/design/layout-line.svg": [
    "67723",
    "96633"
  ],
  "./infinity.svg": [
    "1934",
    "77068"
  ],
  "./remixicon/document/contacts-book-line.svg": [
    "22287",
    "58331"
  ],
  "./remixicon/editor/slash-commands.svg": [
    "4060",
    "75429"
  ],
  "./remixicon/media/rewind-start-mini-line.svg": [
    "25288",
    "20132"
  ],
  "./brands/playmarket.svg": [
    "50415",
    "98296"
  ],
  "./remixicon/media/speaker-3-line.svg": [
    "47210",
    "51108"
  ],
  "./draw.svg": [
    "27468",
    "67631"
  ],
  "./remixicon/arrows/expand-diagonal-fill.svg": [
    "67207",
    "28500"
  ],
  "./remixicon/arrows/contract-left-line.svg": [
    "90446",
    "94529"
  ],
  "./envelope-with-arrow.svg": [
    "31229",
    "81253"
  ],
  "./remixicon/design/ink-bottle-line.svg": [
    "27205",
    "33952"
  ],
  "./remixicon/document/book-open-fill.svg": [
    "93449",
    "64870"
  ],
  "./remixicon/media/speed-up-line.svg": [
    "3200",
    "42258"
  ],
  "./remixicon/media/volume-vibrate-line.svg": [
    "89200",
    "32519"
  ],
  "./student-notes.svg": [
    "81427",
    "89046"
  ],
  "./remixicon/document/folder-add-fill.svg": [
    "87828",
    "34052"
  ],
  "./successful-registration.svg": [
    "7600",
    "26375"
  ],
  "./reorder-option.svg": [
    "44690",
    "27703"
  ],
  "./remixicon/document/file-forbid-line.svg": [
    "36231",
    "45503"
  ],
  "./remixicon/editor/number-8.svg": [
    "54108",
    "53224"
  ],
  "./remixicon/media/fullscreen-fill.svg": [
    "45565",
    "99897"
  ],
  "./remixicon/arrows/arrow-up-fill.svg": [
    "13943",
    "76870"
  ],
  "./remixicon/design/shapes-line.svg": [
    "46838",
    "39261"
  ],
  "./remixicon/editor/subscript-2.svg": [
    "12134",
    "30508"
  ],
  "./remixicon/media/radio-line.svg": [
    "11832",
    "39844"
  ],
  "./remixicon/design/layout-masonry-fill.svg": [
    "96006",
    "12792"
  ],
  "./remixicon/design/layout-right-line.svg": [
    "11763",
    "35818"
  ],
  "./bicolor/bell-with-circle.svg": [
    "42449",
    "52511"
  ],
  "./lesson-module-presentation.svg": [
    "4129",
    "56929"
  ],
  "./remixicon/document/booklet-line.svg": [
    "31634",
    "92979"
  ],
  "./driver.svg": [
    "35632",
    "10050"
  ],
  "./remixicon/media/clapperboard-line.svg": [
    "25629",
    "96038"
  ],
  "./time.svg": [
    "28804",
    "48437"
  ],
  "./remixicon/document/folders-fill.svg": [
    "10959",
    "57289"
  ],
  "./lesson-module-header1.svg": [
    "9819",
    "66168"
  ],
  "./bicolor/book.svg": [
    "89442",
    "93738"
  ],
  "./extensions/word.svg": [
    "22712",
    "3066"
  ],
  "./remixicon/document/folder-chart-fill.svg": [
    "76620",
    "87107"
  ],
  "./remixicon/editor/table-view.svg": [
    "37040",
    "48293"
  ],
  "./remixicon/media/volume-down-line.svg": [
    "78589",
    "29118"
  ],
  "./remixicon/media/forward-15-fill.svg": [
    "63252",
    "94073"
  ],
  "./remixicon/design/align-item-right-fill.svg": [
    "48058",
    "62998"
  ],
  "./remixicon/media/closed-captioning-fill.svg": [
    "29565",
    "8182"
  ],
  "./remixicon/media/notification-4-line.svg": [
    "3748",
    "70220"
  ],
  "./soc-telegram.svg": [
    "42856",
    "87169"
  ],
  "./terms-info.svg": [
    "15223",
    "14383"
  ],
  "./extensions/txt.svg": [
    "40916",
    "16309"
  ],
  "./remixicon/design/drop-fill.svg": [
    "96586",
    "10383"
  ],
  "./remixicon/design/hammer-line.svg": [
    "66853",
    "66104"
  ],
  "./remixicon/media/video-add-fill.svg": [
    "95454",
    "17422"
  ],
  "./lesson-module-code.svg": [
    "71028",
    "24706"
  ],
  "./remixicon/document/file-lock-line.svg": [
    "20704",
    "10282"
  ],
  "./filter-outline.svg": [
    "40584",
    "33781"
  ],
  "./remixicon/media/image-fill.svg": [
    "85978",
    "79043"
  ],
  "./remixicon/document/file-add-line.svg": [
    "61131",
    "8115"
  ],
  "./remixicon/document/newspaper-line.svg": [
    "75706",
    "67106"
  ],
  "./hasChanges-status.svg": [
    "45690",
    "82516"
  ],
  "./remixicon/arrows/arrow-left-double-line.svg": [
    "48678",
    "50825"
  ],
  "./remixicon/arrows/arrow-left-right-fill.svg": [
    "15625",
    "73900"
  ],
  "./extensions/ai.svg": [
    "32687",
    "49468"
  ],
  "./remixicon/design/contrast-2-line.svg": [
    "72206",
    "92486"
  ],
  "./remixicon/design/slice-line.svg": [
    "60362",
    "69250"
  ],
  "./remixicon/document/file-video-line.svg": [
    "43459",
    "75796"
  ],
  "./remixicon/editor/delete-column.svg": [
    "59430",
    "39651"
  ],
  "./remixicon/media/repeat-one-fill.svg": [
    "66380",
    "94312"
  ],
  "./remixicon/document/file-ppt-fill.svg": [
    "60387",
    "80918"
  ],
  "./remixicon/document/folder-user-fill.svg": [
    "14082",
    "28294"
  ],
  "./gears.svg": [
    "17490",
    "41069"
  ],
  "./remixicon/design/brush-3-fill.svg": [
    "41900",
    "16444"
  ],
  "./remixicon/editor/overline.svg": [
    "21174",
    "13486"
  ],
  "./remixicon/document/file-paper-fill.svg": [
    "41725",
    "18846"
  ],
  "./remixicon/media/camera-3-line.svg": [
    "77178",
    "16945"
  ],
  "./mortarboard.svg": [
    "38635",
    "31795"
  ],
  "./upload-small.svg": [
    "94841",
    "11394"
  ],
  "./remixicon/media/image-add-line.svg": [
    "17013",
    "72259"
  ],
  "./course-price.svg": [
    "19188",
    "29622"
  ],
  "./rollback.svg": [
    "90062",
    "50821"
  ],
  "./remixicon/media/camera-switch-line.svg": [
    "74738",
    "94751"
  ],
  "./remixicon/editor/info-i.svg": [
    "55511",
    "22988"
  ],
  "./webinar-new.svg": [
    "62714",
    "10728"
  ],
  "./remixicon/editor/question-mark.svg": [
    "50853",
    "94945"
  ],
  "./extensions/id.svg": [
    "4284",
    "62307"
  ],
  "./remixicon/design/scissors-cut-fill.svg": [
    "65142",
    "47630"
  ],
  "./remixicon/document/file-edit-fill.svg": [
    "306",
    "753"
  ],
  "./remixicon/document/file-shred-fill.svg": [
    "24906",
    "9452"
  ],
  "./remixicon/document/folder-2-fill.svg": [
    "82850",
    "82027"
  ],
  "./remixicon/design/align-item-left-line.svg": [
    "67182",
    "70866"
  ],
  "./remixicon/editor/list-ordered.svg": [
    "13660",
    "27938"
  ],
  "./remixicon/media/album-fill.svg": [
    "91427",
    "67342"
  ],
  "./remixicon/media/landscape-fill.svg": [
    "63318",
    "26247"
  ],
  "./question-digit.svg": [
    "31356",
    "79134"
  ],
  "./remixicon/media/live-line.svg": [
    "89366",
    "59238"
  ],
  "./play-button-arrowhead.svg": [
    "55739",
    "10084"
  ],
  "./remixicon/document/folder-keyhole-fill.svg": [
    "45198",
    "73338"
  ],
  "./remixicon/editor/italic.svg": [
    "48151",
    "8612"
  ],
  "./remixicon/design/edit-circle-fill.svg": [
    "32559",
    "89620"
  ],
  "./remixicon/design/octagon-line.svg": [
    "32003",
    "82361"
  ],
  "./menu-thin.svg": [
    "75444",
    "45404"
  ],
  "./user-group.svg": [
    "95380",
    "41714"
  ],
  "./cloud-check.svg": [
    "74827",
    "43578"
  ],
  "./remixicon/document/book-marked-fill.svg": [
    "96133",
    "41803"
  ],
  "./remixicon/arrows/contract-up-down-line.svg": [
    "66059",
    "50897"
  ],
  "./check-round.svg": [
    "87838",
    "42594"
  ],
  "./graduation-cap.svg": [
    "98349",
    "29170"
  ],
  "./remixicon/document/survey-fill.svg": [
    "49514",
    "15682"
  ],
  "./remixicon/arrows/corner-left-up-line.svg": [
    "42345",
    "11062"
  ],
  "./remixicon/document/file-marked-line.svg": [
    "93257",
    "82280"
  ],
  "./remixicon/design/layout-grid-fill.svg": [
    "48965",
    "11818"
  ],
  "./notifications/main/tachometer.svg": [
    "10234",
    "7426"
  ],
  "./remixicon/document/file-transfer-fill.svg": [
    "81450",
    "33531"
  ],
  "./remixicon/document/folder-cloud-line.svg": [
    "28564",
    "53315"
  ],
  "./soc-vk-square.svg": [
    "8532",
    "20685"
  ],
  "./remixicon/document/folder-shared-line.svg": [
    "75302",
    "52883"
  ],
  "./circle-star.svg": [
    "19425",
    "35622"
  ],
  "./remixicon/arrows/skip-left-fill.svg": [
    "55485",
    "15189"
  ],
  "./link-alt.svg": [
    "87524",
    "3318"
  ],
  "./remixicon/editor/insert-column-right.svg": [
    "86941",
    "90823"
  ],
  "./remixicon/document/folder-music-line.svg": [
    "65179",
    "75919"
  ],
  "./remixicon/document/file-add-fill.svg": [
    "88599",
    "2790"
  ],
  "./extensions/arrow-round-revert.svg": [
    "3195",
    "4682"
  ],
  "./remixicon/document/file-user-fill.svg": [
    "60582",
    "40598"
  ],
  "./desktop.svg": [
    "60921",
    "65347"
  ],
  "./remixicon/arrows/arrow-left-fill.svg": [
    "99183",
    "71444"
  ],
  "./mobile.svg": [
    "77329",
    "17336"
  ],
  "./long-arrow-right.svg": [
    "88074",
    "97198"
  ],
  "./remixicon/design/clockwise-2-line.svg": [
    "85790",
    "88672"
  ],
  "./remixicon/design/layout-row-fill.svg": [
    "78171",
    "46439"
  ],
  "./remixicon/media/repeat-fill.svg": [
    "23750",
    "30759"
  ],
  "./remixicon/arrows/corner-down-right-fill.svg": [
    "91851",
    "60392"
  ],
  "./word-linc.svg": [
    "86558",
    "55608"
  ],
  "./circle-arrow-process.svg": [
    "11768",
    "37168"
  ],
  "./remixicon/document/file-copy-fill.svg": [
    "27892",
    "65404"
  ],
  "./remixicon/media/video-add-line.svg": [
    "47705",
    "74710"
  ],
  "./remixicon/document/sticky-note-add-line.svg": [
    "76074",
    "4809"
  ],
  "./line-solid.svg": [
    "3673",
    "49302"
  ],
  "./remixicon/media/equalizer-2-fill.svg": [
    "51444",
    "70187"
  ],
  "./remixicon/document/draft-fill.svg": [
    "59133",
    "61512"
  ],
  "./remixicon/design/input-method-line.svg": [
    "29672",
    "61309"
  ],
  "./pause-round.svg": [
    "87",
    "33416"
  ],
  "./phone-role.svg": [
    "66901",
    "41935"
  ],
  "./remixicon/design/screenshot-line.svg": [
    "74921",
    "18136"
  ],
  "./grip-dots-vertical.svg": [
    "72756",
    "26917"
  ],
  "./bicolor/check-rounded.svg": [
    "32502",
    "2134"
  ],
  "./landscape.svg": [
    "48153",
    "21741"
  ],
  "./remixicon/document/receipt-fill.svg": [
    "81906",
    "17380"
  ],
  "./remixicon/media/closed-captioning-line.svg": [
    "53378",
    "8071"
  ],
  "./lesson-module-table.svg": [
    "61006",
    "48351"
  ],
  "./remixicon/media/dv-fill.svg": [
    "74670",
    "3287"
  ],
  "./remixicon/media/rewind-line.svg": [
    "43745",
    "80020"
  ],
  "./publish-all.svg": [
    "20285",
    "58999"
  ],
  "./remixicon/design/shapes-fill.svg": [
    "99506",
    "79448"
  ],
  "./question-rounded.svg": [
    "18596",
    "50576"
  ],
  "./tick-circle.svg": [
    "34766",
    "30121"
  ],
  "./remixicon/arrows/expand-width-line.svg": [
    "25252",
    "12722"
  ],
  "./remixicon/document/bill-fill.svg": [
    "46175",
    "16460"
  ],
  "./left-landscape-first-loopers.svg": [
    "12858",
    "66970"
  ],
  "./remixicon/design/layout-horizontal-fill.svg": [
    "93057",
    "96321"
  ],
  "./pop-up.svg": [
    "82502",
    "44174"
  ],
  "./remixicon/document/file-transfer-line.svg": [
    "59112",
    "67451"
  ],
  "./angle-up-large.svg": [
    "69659",
    "97583"
  ],
  "./remixicon/media/speed-fill.svg": [
    "36409",
    "56714"
  ],
  "./remixicon/document/folder-chart-2-fill.svg": [
    "99865",
    "36620"
  ],
  "./remixicon/design/focus-2-line.svg": [
    "87341",
    "15097"
  ],
  "./redirect-square.svg": [
    "90575",
    "90155"
  ],
  "./remixicon/design/layout-right-fill.svg": [
    "58210",
    "71704"
  ],
  "./remixicon/media/video-fill.svg": [
    "47523",
    "87520"
  ],
  "./remixicon/media/radio-2-line.svg": [
    "47071",
    "83782"
  ],
  "./remixicon/design/brush-fill.svg": [
    "64495",
    "84579"
  ],
  "./dot-circle.svg": [
    "44416",
    "32694"
  ],
  "./arrow-thin-left.svg": [
    "35606",
    "31141"
  ],
  "./alarm.svg": [
    "15930",
    "55181"
  ],
  "./download.svg": [
    "1466",
    "11812"
  ],
  "./bookmark.svg": [
    "96773",
    "70976"
  ],
  "./remixicon/document/file-image-line.svg": [
    "85835",
    "4860"
  ],
  "./remixicon/media/skip-forward-mini-line.svg": [
    "34641",
    "74706"
  ],
  "./remixicon/arrows/arrow-go-forward-fill.svg": [
    "62876",
    "93266"
  ],
  "./remixicon/document/folder-4-line.svg": [
    "94350",
    "34167"
  ],
  "./bucket.svg": [
    "7836",
    "98325"
  ],
  "./remixicon/document/file-close-fill.svg": [
    "63451",
    "85323"
  ],
  "./remixicon/document/file-download-line.svg": [
    "32602",
    "22167"
  ],
  "./remixicon/document/file-4-fill.svg": [
    "56037",
    "32956"
  ],
  "./audio-rate.svg": [
    "11809",
    "20247"
  ],
  "./arrow-round-clock.svg": [
    "83081",
    "2447"
  ],
  "./remixicon/arrows/collapse-diagonal-2-fill.svg": [
    "8924",
    "29379"
  ],
  "./remixicon/document/file-zip-fill.svg": [
    "15886",
    "23854"
  ],
  "./remixicon/design/shape-line.svg": [
    "4729",
    "72581"
  ],
  "./remixicon/editor/emphasis-cn.svg": [
    "79855",
    "49175"
  ],
  "./remixicon/editor/font-family.svg": [
    "21642",
    "87610"
  ],
  "./remixicon/editor/font-size-2.svg": [
    "76937",
    "55878"
  ],
  "./lesson-module-about.svg": [
    "31429",
    "35077"
  ],
  "./plan-new-school-free.svg": [
    "93440",
    "28090"
  ],
  "./remixicon/editor/organization-chart.svg": [
    "19616",
    "50662"
  ],
  "./remixicon/editor/text-wrap.svg": [
    "3974",
    "28066"
  ],
  "./remixicon/media/equalizer-2-line.svg": [
    "99078",
    "55132"
  ],
  "./remixicon/media/image-add-fill.svg": [
    "5046",
    "38767"
  ],
  "./remixicon/design/crosshair-fill.svg": [
    "64117",
    "83557"
  ],
  "./question-relation.svg": [
    "95501",
    "43513"
  ],
  "./remixicon/media/play-reverse-mini-line.svg": [
    "66961",
    "80426"
  ],
  "./remixicon/media/image-edit-line.svg": [
    "39467",
    "2889"
  ],
  "./remixicon/media/record-circle-line.svg": [
    "58513",
    "83406"
  ],
  "./remixicon/media/webcam-line.svg": [
    "16462",
    "43550"
  ],
  "./remixicon/editor/separator.svg": [
    "49196",
    "66631"
  ],
  "./remixicon/document/markdown-line.svg": [
    "4862",
    "11141"
  ],
  "./remixicon/design/layout-6-fill.svg": [
    "41435",
    "98179"
  ],
  "./remixicon/media/play-list-line.svg": [
    "76604",
    "13584"
  ],
  "./rounded-down.svg": [
    "4303",
    "49597"
  ],
  "./close-circle-fill.svg": [
    "91388",
    "82732"
  ],
  "./gift.svg": [
    "77361",
    "64873"
  ],
  "./remixicon/arrows/skip-down-fill.svg": [
    "88141",
    "91441"
  ],
  "./remixicon/design/brush-2-fill.svg": [
    "52784",
    "52345"
  ],
  "./remixicon/design/crop-2-fill.svg": [
    "38468",
    "71834"
  ],
  "./remixicon/document/file-fill.svg": [
    "64603",
    "41882"
  ],
  "./remixicon/document/file-ppt-2-line.svg": [
    "23696",
    "35193"
  ],
  "./remixicon/media/replay-15-fill.svg": [
    "78638",
    "71513"
  ],
  "./test-image-and-select.svg": [
    "83012",
    "93197"
  ],
  "./arrow-left-long.svg": [
    "85377",
    "73540"
  ],
  "./remixicon/arrows/corner-down-right-line.svg": [
    "38448",
    "71470"
  ],
  "./remixicon/design/layout-vertical-line.svg": [
    "39423",
    "7353"
  ],
  "./remixicon/media/pause-large-line.svg": [
    "94622",
    "13429"
  ],
  "./cloud-synced.svg": [
    "43011",
    "73676"
  ],
  "./remixicon/document/folder-lock-line.svg": [
    "1717",
    "4855"
  ],
  "./extensions/folder.svg": [
    "78955",
    "34043"
  ],
  "./remixicon/arrows/expand-up-down-line.svg": [
    "80001",
    "41733"
  ],
  "./remixicon/editor/sort-alphabet-asc.svg": [
    "14559",
    "7902"
  ],
  "./copy-new.svg": [
    "60605",
    "50395"
  ],
  "./lock-open.svg": [
    "92567",
    "74114"
  ],
  "./remixicon/editor/delete-row.svg": [
    "11498",
    "10794"
  ],
  "./remixicon/media/mic-2-fill.svg": [
    "5719",
    "77395"
  ],
  "./remixicon/document/folder-check-fill.svg": [
    "59071",
    "76451"
  ],
  "./remixicon/media/phone-camera-line.svg": [
    "92209",
    "10479"
  ],
  "./remixicon/arrows/arrow-right-circle-line.svg": [
    "25799",
    "83005"
  ],
  "./remixicon/design/mark-pen-line.svg": [
    "31417",
    "15500"
  ],
  "./remixicon/media/voiceprint-fill.svg": [
    "2027",
    "60932"
  ],
  "./arrow-round.svg": [
    "28986",
    "10711"
  ],
  "./remixicon/media/clapperboard-fill.svg": [
    "99896",
    "98217"
  ],
  "./remixicon/design/color-filter-fill.svg": [
    "79611",
    "69474"
  ],
  "./triangle-rounded-down.svg": [
    "40897",
    "76024"
  ],
  "./plus-large.svg": [
    "91157",
    "86613"
  ],
  "./user-robot-role.svg": [
    "68977",
    "56558"
  ],
  "./card-cancel.svg": [
    "80524",
    "51450"
  ],
  "./remixicon/media/webcam-fill.svg": [
    "62324",
    "20898"
  ],
  "./soc-facebook-square.svg": [
    "83674",
    "12926"
  ],
  "./remixicon/editor/bring-to-front.svg": [
    "63421",
    "81782"
  ],
  "./remixicon/document/markdown-fill.svg": [
    "14012",
    "31988"
  ],
  "./remixicon/design/screenshot-2-line.svg": [
    "10042",
    "34066"
  ],
  "./analytics.svg": [
    "90694",
    "17865"
  ],
  "./remixicon/document/contacts-book-2-line.svg": [
    "23771",
    "18230"
  ],
  "./remixicon/media/play-large-fill.svg": [
    "10971",
    "23235"
  ],
  "./trash-reverse.svg": [
    "58075",
    "85808"
  ],
  "./remixicon/design/layout-left-fill.svg": [
    "41667",
    "37773"
  ],
  "./remixicon/media/play-reverse-large-line.svg": [
    "25769",
    "53026"
  ],
  "./remixicon/editor/strikethrough-2.svg": [
    "16285",
    "9612"
  ],
  "./remixicon/editor/list-ordered-2.svg": [
    "63177",
    "86596"
  ],
  "./play-button-disablad.svg": [
    "48907",
    "4266"
  ],
  "./remixicon/design/layout-5-line.svg": [
    "64587",
    "15863"
  ],
  "./calendar.svg": [
    "53442",
    "55228"
  ],
  "./remixicon/editor/list-view.svg": [
    "17426",
    "79672"
  ],
  "./remixicon/document/file-download-fill.svg": [
    "22469",
    "71706"
  ],
  "./layers2.svg": [
    "54622",
    "81201"
  ],
  "./remixicon/design/t-box-line.svg": [
    "84684",
    "96319"
  ],
  "./comment-role.svg": [
    "29135",
    "67108"
  ],
  "./filter.svg": [
    "21083",
    "24220"
  ],
  "./remixicon/design/layout-top-line.svg": [
    "35576",
    "40740"
  ],
  "./remixicon/arrows/arrow-down-s-fill.svg": [
    "68033",
    "73246"
  ],
  "./remixicon/design/sip-line.svg": [
    "65496",
    "90749"
  ],
  "./teacher-role.svg": [
    "89181",
    "721"
  ],
  "./card-circle.svg": [
    "26479",
    "76530"
  ],
  "./remixicon/design/ruler-2-fill.svg": [
    "28601",
    "95606"
  ],
  "./remixicon/design/table-alt-line.svg": [
    "19001",
    "76324"
  ],
  "./remixicon/media/landscape-line.svg": [
    "37673",
    "68208"
  ],
  "./remixicon/design/align-item-bottom-line.svg": [
    "57352",
    "97886"
  ],
  "./camera-movie.svg": [
    "6990",
    "71187"
  ],
  "./extensions/excel.svg": [
    "85357",
    "145"
  ],
  "./remixicon/arrows/expand-left-right-fill.svg": [
    "93642",
    "43723"
  ],
  "./remixicon/design/quill-pen-fill.svg": [
    "35887",
    "55104"
  ],
  "./navigation-menu.svg": [
    "90354",
    "7706"
  ],
  "./remixicon/design/align-item-horizontal-center-line.svg": [
    "41898",
    "54913"
  ],
  "./remixicon/document/folder-history-line.svg": [
    "63824",
    "31443"
  ],
  "./remixicon/media/gallery-upload-fill.svg": [
    "11166",
    "21996"
  ],
  "./remixicon/editor/wubi-input.svg": [
    "57690",
    "942"
  ],
  "./remixicon/media/rhythm-fill.svg": [
    "21549",
    "75103"
  ],
  "./remixicon/editor/mind-map.svg": [
    "62452",
    "45502"
  ],
  "./partner-teacher.svg": [
    "46270",
    "96006"
  ],
  "./remixicon/document/folder-user-line.svg": [
    "33165",
    "20052"
  ],
  "./remixicon/editor/sketching.svg": [
    "16605",
    "46047"
  ],
  "./remixicon/document/file-pdf-fill.svg": [
    "76378",
    "30820"
  ],
  "./remixicon/arrows/arrow-down-wide-fill.svg": [
    "68167",
    "16702"
  ],
  "./remixicon/editor/stacked-view.svg": [
    "83288",
    "80399"
  ],
  "./remixicon/document/file-lock-fill.svg": [
    "32736",
    "88763"
  ],
  "./arrow-up-right-from-square.svg": [
    "23295",
    "86559"
  ],
  "./remixicon/arrows/arrow-turn-forward-line.svg": [
    "2505",
    "97314"
  ],
  "./danger-round.svg": [
    "51900",
    "20749"
  ],
  "./remixicon/arrows/arrow-down-fill.svg": [
    "15604",
    "65465"
  ],
  "./remixicon/editor/ai-generate.svg": [
    "11283",
    "86840"
  ],
  "./text.svg": [
    "89013",
    "34476"
  ],
  "./remixicon/document/file-info-fill.svg": [
    "62782",
    "77978"
  ],
  "./soc-telegram-round.svg": [
    "33786",
    "5485"
  ],
  "./remixicon/media/volume-off-vibrate-line.svg": [
    "58417",
    "40292"
  ],
  "./remixicon/editor/gallery-view-2.svg": [
    "39944",
    "43709"
  ],
  "./remixicon/design/layout-top-fill.svg": [
    "47869",
    "40809"
  ],
  "./remixicon/media/rewind-start-mini-fill.svg": [
    "70471",
    "65869"
  ],
  "./extensions/code.svg": [
    "51567",
    "77277"
  ],
  "./linked.svg": [
    "25441",
    "68491"
  ],
  "./remixicon/document/file-2-line.svg": [
    "41774",
    "97634"
  ],
  "./remixicon/document/file-3-fill.svg": [
    "1346",
    "76236"
  ],
  "./remixicon/document/file-excel-line.svg": [
    "43992",
    "97622"
  ],
  "./remixicon/arrows/arrow-go-back-fill.svg": [
    "11843",
    "47657"
  ],
  "./remixicon/arrows/arrow-left-down-line.svg": [
    "90124",
    "31200"
  ],
  "./remixicon/design/contrast-drop-2-line.svg": [
    "1536",
    "86977"
  ],
  "./remixicon/document/file-excel-2-line.svg": [
    "25224",
    "16398"
  ],
  "./remixicon/document/folder-zip-fill.svg": [
    "32682",
    "60760"
  ],
  "./remixicon/media/order-play-line.svg": [
    "5011",
    "38818"
  ],
  "./remixicon/media/pause-circle-fill.svg": [
    "75019",
    "61615"
  ],
  "./remixicon/media/play-list-fill.svg": [
    "8112",
    "88263"
  ],
  "./remixicon/document/folder-transfer-line.svg": [
    "57715",
    "86602"
  ],
  "./remixicon/design/edit-fill.svg": [
    "6175",
    "30319"
  ],
  "./remixicon/editor/draggable.svg": [
    "1031",
    "96487"
  ],
  "./remixicon/media/play-reverse-fill.svg": [
    "98381",
    "19113"
  ],
  "./remixicon/design/edit-box-line.svg": [
    "96622",
    "89548"
  ],
  "./remixicon/document/file-list-2-line.svg": [
    "65858",
    "91826"
  ],
  "./remixicon/document/folder-unknow-line.svg": [
    "89577",
    "31507"
  ],
  "./remixicon/design/align-item-left-fill.svg": [
    "1557",
    "24299"
  ],
  "./remixicon/media/replay-30-line.svg": [
    "94819",
    "60319"
  ],
  "./remixicon/media/4k-fill.svg": [
    "68969",
    "21822"
  ],
  "./remixicon/media/image-2-line.svg": [
    "64522",
    "49791"
  ],
  "./rounded-left.svg": [
    "24506",
    "88628"
  ],
  "./notifications/status/clock-circle.svg": [
    "14212",
    "11005"
  ],
  "./remixicon/arrows/corner-right-up-line.svg": [
    "919",
    "73998"
  ],
  "./notifications/status/check-flower.svg": [
    "97103",
    "75516"
  ],
  "./help-circle.svg": [
    "39416",
    "2053"
  ],
  "./remixicon/arrows/skip-left-line.svg": [
    "43089",
    "33344"
  ],
  "./remixicon/document/file-upload-fill.svg": [
    "33482",
    "6346"
  ],
  "./calendar-clock.svg": [
    "22880",
    "39291"
  ],
  "./remixicon/document/folder-check-line.svg": [
    "10740",
    "91413"
  ],
  "./remixicon/document/folder-chart-2-line.svg": [
    "66500",
    "54502"
  ],
  "./remixicon/document/folder-video-fill.svg": [
    "84716",
    "48241"
  ],
  "./layers-3.svg": [
    "49820",
    "52853"
  ],
  "./remixicon/arrows/arrow-right-double-line.svg": [
    "85746",
    "76505"
  ],
  "./dollar-round.svg": [
    "60733",
    "39297"
  ],
  "./pencil-alt.svg": [
    "28666",
    "66530"
  ],
  "./remixicon/design/layout-6-line.svg": [
    "16713",
    "64693"
  ],
  "./extensions/picture.svg": [
    "86390",
    "23006"
  ],
  "./diploma.svg": [
    "51085",
    "841"
  ],
  "./remixicon/media/aspect-ratio-line.svg": [
    "23124",
    "58113"
  ],
  "./remixicon/media/picture-in-picture-exit-fill.svg": [
    "4819",
    "1510"
  ],
  "./remixicon/document/numbers-fill.svg": [
    "78741",
    "83382"
  ],
  "./upload.svg": [
    "60376",
    "39853"
  ],
  "./callout-info.svg": [
    "35845",
    "43575"
  ],
  "./remixicon/document/file-cloud-fill.svg": [
    "82756",
    "17238"
  ],
  "./image-switch.svg": [
    "36353",
    "80218"
  ],
  "./remixicon/document/file-excel-fill.svg": [
    "15934",
    "45395"
  ],
  "./remixicon/media/broadcast-line.svg": [
    "21218",
    "63910"
  ],
  "./empty-test.svg": [
    "67722",
    "30369"
  ],
  "./bicolor/chat.svg": [
    "79707",
    "98468"
  ],
  "./remixicon/media/surround-sound-line.svg": [
    "30057",
    "57684"
  ],
  "./user.svg": [
    "64003",
    "91045"
  ],
  "./remixicon/arrows/corner-up-left-double-line.svg": [
    "9759",
    "64013"
  ],
  "./pencil.svg": [
    "46743",
    "84587"
  ],
  "./remixicon/document/file-search-line.svg": [
    "1334",
    "47444"
  ],
  "./remixicon/design/crosshair-2-line.svg": [
    "47697",
    "41327"
  ],
  "./remixicon/design/layout-bottom-2-fill.svg": [
    "94679",
    "73179"
  ],
  "./remixicon/design/crosshair-2-fill.svg": [
    "30945",
    "78353"
  ],
  "./remixicon/document/book-fill.svg": [
    "19707",
    "18614"
  ],
  "./remixicon/document/file-shield-line.svg": [
    "23450",
    "68797"
  ],
  "./remixicon/media/dvd-fill.svg": [
    "66648",
    "18197"
  ],
  "./remixicon/media/gallery-upload-line.svg": [
    "2895",
    "32919"
  ],
  "./remixicon/media/memories-line.svg": [
    "14332",
    "66792"
  ],
  "./stream.svg": [
    "68586",
    "53954"
  ],
  "./remixicon/document/folder-image-fill.svg": [
    "42922",
    "59764"
  ],
  "./arrow-left.svg": [
    "58872",
    "54859"
  ],
  "./course-published.svg": [
    "72257",
    "58018"
  ],
  "./drag-vertical.svg": [
    "89463",
    "15399"
  ],
  "./remixicon/arrows/corner-up-right-double-fill.svg": [
    "44603",
    "24411"
  ],
  "./remixicon/document/file-list-fill.svg": [
    "28193",
    "14074"
  ],
  "./remixicon/editor/align-center.svg": [
    "39913",
    "46900"
  ],
  "./remixicon/design/clockwise-2-fill.svg": [
    "49144",
    "23611"
  ],
  "./remixicon/arrows/expand-diagonal-2-line.svg": [
    "73721",
    "77755"
  ],
  "./remixicon/media/skip-forward-mini-fill.svg": [
    "24085",
    "30955"
  ],
  "./remixicon/editor/subscript.svg": [
    "5077",
    "65979"
  ],
  "./remixicon/media/stop-large-fill.svg": [
    "23217",
    "95225"
  ],
  "./rotate-img.svg": [
    "98237",
    "262"
  ],
  "./notifications/main/time-add.svg": [
    "63170",
    "52662"
  ],
  "./paperbox.svg": [
    "51363",
    "68351"
  ],
  "./log-in.svg": [
    "65301",
    "26499"
  ],
  "./remixicon/arrows/corner-down-left-fill.svg": [
    "50907",
    "85101"
  ],
  "./camera.svg": [
    "61329",
    "13148"
  ],
  "./arrow-right-round.svg": [
    "43803",
    "1763"
  ],
  "./remixicon/design/flip-vertical-2-line.svg": [
    "55835",
    "40511"
  ],
  "./login.svg": [
    "66606",
    "37604"
  ],
  "./remixicon/design/shape-2-fill.svg": [
    "47808",
    "80707"
  ],
  "./remixicon/arrows/arrow-drop-left-line.svg": [
    "26264",
    "95325"
  ],
  "./remixicon/editor/flow-chart.svg": [
    "36445",
    "60961"
  ],
  "./remixicon/document/file-chart-2-line.svg": [
    "17456",
    "6062"
  ],
  "./plus.svg": [
    "47417",
    "88354"
  ],
  "./remixicon/arrows/expand-left-fill.svg": [
    "12955",
    "90913"
  ],
  "./remixicon/design/magic-fill.svg": [
    "39470",
    "74349"
  ],
  "./remixicon/document/file-copy-2-fill.svg": [
    "81725",
    "67325"
  ],
  "./remixicon/media/image-circle-fill.svg": [
    "13819",
    "17385"
  ],
  "./users.svg": [
    "76896",
    "41185"
  ],
  "./notifications/main/two-hands.svg": [
    "98332",
    "51457"
  ],
  "./multiple-users.svg": [
    "94843",
    "96503"
  ],
  "./remixicon/document/file-list-2-fill.svg": [
    "46258",
    "31655"
  ],
  "./square-quote.svg": [
    "48695",
    "98193"
  ],
  "./remixicon/design/scissors-2-fill.svg": [
    "8150",
    "84655"
  ],
  "./remixicon/design/shadow-fill.svg": [
    "17695",
    "84923"
  ],
  "./lesson-module-article.svg": [
    "13177",
    "43743"
  ],
  "./arrow-down-round-fill.svg": [
    "40173",
    "11525"
  ],
  "./remixicon/document/contacts-book-2-fill.svg": [
    "92105",
    "78144"
  ],
  "./remixicon/document/file-code-line.svg": [
    "91184",
    "28753"
  ],
  "./remixicon/document/folder-upload-fill.svg": [
    "2920",
    "49393"
  ],
  "./remixicon/document/file-chart-line.svg": [
    "31873",
    "44687"
  ],
  "./bicolor/balance.svg": [
    "1714",
    "74133"
  ],
  "./remixicon/editor/align-left.svg": [
    "65542",
    "22977"
  ],
  "./remixicon/document/folder-reduce-fill.svg": [
    "11710",
    "30184"
  ],
  "./remixicon/editor/merge-cells-horizontal.svg": [
    "99923",
    "78362"
  ],
  "./notifications/status/comment.svg": [
    "23888",
    "81210"
  ],
  "./remixicon/media/polaroid-fill.svg": [
    "23730",
    "84343"
  ],
  "./remixicon/document/folder-upload-line.svg": [
    "50118",
    "9402"
  ],
  "./money-output.svg": [
    "98933",
    "45075"
  ],
  "./remixicon/document/file-pdf-2-line.svg": [
    "64615",
    "94851"
  ],
  "./like.svg": [
    "52955",
    "25910"
  ],
  "./remixicon/arrows/skip-up-line.svg": [
    "61097",
    "89719"
  ],
  "./soc-vk.svg": [
    "9546",
    "9084"
  ],
  "./remixicon/editor/number-2.svg": [
    "1979",
    "90923"
  ],
  "./cloud-success.svg": [
    "8395",
    "20499"
  ],
  "./angle-left-fill.svg": [
    "81031",
    "63663"
  ],
  "./notifications/main/calendar-clock.svg": [
    "26575",
    "46152"
  ],
  "./refresh-fill.svg": [
    "7230",
    "59598"
  ],
  "./remixicon/arrows/corner-up-right-fill.svg": [
    "87447",
    "6707"
  ],
  "./remixicon/design/shadow-line.svg": [
    "72237",
    "44269"
  ],
  "./remixicon/document/folder-close-fill.svg": [
    "33483",
    "59693"
  ],
  "./star.svg": [
    "1238",
    "26192"
  ],
  "./check-thin.svg": [
    "89132",
    "46478"
  ],
  "./arrow-right.svg": [
    "62676",
    "52292"
  ],
  "./question-image-and-select.svg": [
    "86465",
    "35965"
  ],
  "./remixicon/arrows/expand-left-right-line.svg": [
    "71777",
    "96728"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 1 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6565;
module.exports = webpackAsyncContext;
